import React from 'react';
import PropTypes, { instanceOf } from 'prop-types';
import { withStyles } from 'material-ui/styles';
import * as URI from 'urijs';
import { withCookies, Cookies } from 'react-cookie';
import { addCommas, createValueToEntryMap, flattenMap, isEnabledUserRole, isMinLetterOrderCount, flattenNestedMenu } from '../../utils/utils';
import { isEnableFollowCallHouseList } from '../../utils/userOptionUtils'
import { ADDRESS_PER_PAGE, ADDRESS_NAME_PREVIEW_LIMIT } from '../../constants/Constants';
import { ERR_MOVE_NG_SENDINGS_NO_CORPORATE_NUM } from '../../constants/ErrorMessages';

import {
  AddressBookTab,
  DialogType,
  HouseListDirectory,
  LinkCorporationStatusType,
  WarningAddressType,
  DifferenceType,
  TagType,
  HouseListSortType,
  ErrorAddressSortType,
  WarningAddressSortType,
} from '../../constants/ComponentTypes';
import { linkCorporationStatusMenu, sentStatusMenu, honorificNestedMenu, departmentNestedMenu, prefectureNameMenu, differenceTypeMenu, statusMenu, warningTypeMenu, followCallOrderStatusMenu } from '../../constants/SidebarValues';
import AddFromExcelDialog from './dialogs/AddFromExcelDialog';
import AddNgExcelDialog from './dialogs/AddNgExcelDialog';
import AddressBookHeader from './AddressBookHeader';
import AddressBookSidebar from './AddressBookSidebar';
import AddressBookUtil from './utils/AddressBookUtil'
import AddressTable from './AddressTable';
import AddAddressDialog from './dialogs/AddAddressDialog';
import SelectAddAddressDialog from './dialogs/SelectAddAddressDialog';
import ManageTagsDialog from './dialogs/ManageTagsDialog';
import EditTagsDialog from './dialogs/EditTagsDialog';
import CreateListDialog from './dialogs/CreateListDialog';
import BottomMenu from '../common/BottomMenu';
import Button from '../Parts/Button';
import CancelCircle from '../Icons/CancelCircle';
import Chip from 'material-ui/Chip';
import ConfirmDialog from '../common/ConfirmDialog';
import ConfirmFollowCallOrderDialog from './dialogs/ConfirmFollowCallOrderDialog';
import SubmitFollowCallOrderDialog from './dialogs/SubmitFollowCallOrderDialog';
import DeleteDialog from '../common/DeleteDialog';
import DetailDialog from './dialogs/DetailDialog'
import OrderDisableDialog from './dialogs/OrderDisableDialog';
import EditAddressDialog from './dialogs/EditAddressDialog';
import EditNgItemDialog from './dialogs/EditNgItemDialog';
import Header from '../common/Header';
import Loader from '../Parts/Loader';
import NoAddressPage from './NoAddressPage';
import NotificationBar from '../Parts/NotificationBar.jsx'
import Typography from 'material-ui/Typography'
import Wrapper from '../common/Wrapper';
import Exclamation from '../Icons/Exclamation';
import SelectOptionDialog from '../common/SelectOptionDialog';
import WarningLabel from './WarningLabel';
import PlanDialog from '../SendLetter/dialogs/PlanDialog';
import DemoDialog from './dialogs/DemoDialog';
import SalesforceInfoBox from './dialogs/SalesforceInfoBox';
import IntegrationInquiryDialog from "../AccountSetting/Integration/IntegrationInquiryDialog";
import qs from 'qs';

import MuiButton from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import { InputAdornment } from 'material-ui/Input';
import Search from 'material-ui-icons/Search';
import moment from 'moment';
import ConfirmSendDialog from '../common/ConfirmSendDialog';

const { Set, Map } = require('immutable');

const styles = () => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },

  main: {
    background: "#F4F6F9",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    position: 'relative',
    overflow: 'hidden',
  },

  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'white',
    borderBottom: '1px solid  #D8DBDF',
  },

  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    justifyContent: 'center',
  },

  sidebar: {
    backgroundColor: '#FFFFFF',
    minWidth: '300px',
    maxWidth: '300px',
    overflowX: "hidden",
    flex: '1',
    marginTop: '35px',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
    zIndex: 2,
  },

  mainContainer: {
    flex: '4',
    position: 'relative',
    overflowY: 'scroll',
    boxSizing: 'border-box',
    padding: '35px 20px 0px 20px',
  },

  addressTableContainer: {
    margin: '20px 0px',
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
  },

  addressTableHeader: {
    padding: '25px 30px',
    boxSizing: 'border-box',
    background: '#FFFFFF',
    display: 'flex',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
  },

  addressTableContent: {
    marginTop: '35px'
  },

  ngListSearchBar: {
    margin: '0px 150px 20px 150px',
  },

  ngListSearchRoot: {
    height: '39px',
    borderRadius: '30px',
    width: '300px',
    minHeight: 'unset',
    padding: '0px 12px',
    marginBottom: '20px',
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    alignItems: 'center',
    '&:focus-within': {
      borderColor: '#1A65FF',
    },
  },

  ngListSearchInput: {
    border: 'none',
    padding: '0px',
  },

  totalCount: {
    minWidth: '90px',
  },

  bottomMenu: {
    width: "calc(100% - 300px)",
    position: 'fixed',
    bottom: 0,
    marginLeft: '-20px',
  },

  chipRoot: {
    marginRight: '10px',
    marginTop: '8px',
    float: 'left',
    backgroundColor: 'rgba(26,101,255,.05)',
    border: '#1A65FF solid 1px',
    color: '#181819',
    height: '27px',
    borderRadius: '2px',
  },

  chipLabel: {
    padding: '5px 17px 5px 10px',
    fontSize: '11px',
  },

  chipContainer: {
    marginLeft: '50px',
  },

  linkBtn: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  addAddressBtn: {
    color: '#1A65FF',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'rgba(26,101,255,.05)',
    }
  },

  scrollBtn: {
    position: 'fixed',
    bottom: '20px',
    left: '320px',
    zIndex: 1,
  },

  inline: {
    display: 'inline-flex',
    alignItems: 'center',
  },

  warningMessage: {
    cursor: 'pointer',
    display: 'flow-root',
  },

  searchNotifContainer: {
    margin: '0px 150px 20px 150px',
  },

  demoNotification: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  demoButton: {
    color: '#181819',
    fontSize: '13px',
    minWidth: 'unset',
    minHeight: 'unset',
    padding: '1px',
    marginLeft: '10px',
    textDecoration: 'underline',
  },
});

const prefectureValueToEntryMap = createValueToEntryMap(prefectureNameMenu);
const statusValueToEntryMap = createValueToEntryMap(statusMenu);
const sentStatusValueToEntryMap = createValueToEntryMap(sentStatusMenu);
const followCallOrderStatusValueToEntryMap = createValueToEntryMap(followCallOrderStatusMenu);
const honorificMenu = flattenNestedMenu(honorificNestedMenu);
const departmentMenu = flattenNestedMenu(departmentNestedMenu);

class HouseList extends React.Component {
  initialState = {
    editItems: [],
    filteredItems: [],
    isSelectAll: false,
    selectCount: 0,
    message: '',
    messageType: 'success',
    selectedItems: Set(), // ids of all the selectedItems
    unselectedItems: Set(), // ids of all the excluded items, only used in "selectAll" mode
    showAddExcelDialog: false,
    showAddFollowCallAddressExcelDialog: false,
    showCreateDialog: false,
    showCreateFollowCallAddressDialog: false,
    showDeleteDialog: false,
    showDetailDialog: false,
    showEditDialog: false,
    showFollowCallAddressEditDialog: false,
    showNotification: false,
    showScrollBtn: false,
    showAddAddressDialog: false,
    showAddFollowCallAddressDialog: false,
    showSelectAddAddressDialog: false,
    showCreateNgItemDialog: false,
    showEditNgItemDialog: false,
    showAddNgExcelDialog: false,
    showSearchNotification: false,
    showSelectOptionDialog: false,
    showManageTagsDialog: false,
    showEditTagsDialog: false,
    showCreateListDialog: false,
    showConfirmDialog: false,
    showConfirmSendDialog: false,
    showOrderDisableDialog: false,
    showPlanDialog: false,
    showDemoDialog: false,
    showInfoBox: false,
    undoable: false,
    showInquiryDialog: false,
    showConfirmFollowCallOrderDialog: false,
    showSubmitFollowCallOrderDialog: false,
    filterValue: {
      tag: Set(),
      prefecture_name: Map(),
      sent_status: Map(),
      sent_only_from: '',
      sent_only_to: '',
      sent_except_from: '',
      sent_except_to: '',
      link_corporation_status: Set(),
      position: Set(),
      branch: Set(),
      import_history_tag: Set(),
      difference_type: Set(),
      timeline_status: Map(),
      follow_call_order_status: Map(),
      follow_call_order_only_from: '',
      follow_call_order_only_to: '',
      follow_call_order_except_from: '',
      follow_call_order_except_to: '',
      warning_type: Set(),
      letter_order_address: false,
      follow_call_address: false,
      salesforce_address: false,
      search: '',
    },
    sortType: HouseListSortType.SORT_TYPE_CREATED_AT_DESC.value,
    prevSearch: '',
    isSidebarLoaded: false,
    isLoadingCheck: false,
    letterOrderItem: Map(),
    followCallOrderItem: Map(),
    isMixedAddresses: false,
    modalMessage: '',
    hasLetterOrderHistoryNames: [],
    duplicateNames: [],
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentDidMount() {
    let query = { 'paging': 1, 'page': 1, 'per_page': ADDRESS_PER_PAGE };
    let overwrite = true;

    this.getCookies('showCorporateNumberWarning', true);
    this.getCookies('showAddressDiffWarning', true);
    this.getCookies('showCompanyNameDiffWarning', true);
    this.getCookies('showCloseWarning', true);

    if (this.props.type === HouseListDirectory.ERROR.name) {
      this.props.getErrorAddress(query, overwrite);
    } else if (this.props.type === HouseListDirectory.WARNING.name) {
      this.props.getWarningAddress(query, overwrite);
    } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
      this.props.getNgSendings(query, overwrite);
    } else {
      if (this.props.routerInfo.state &&
        this.props.routerInfo.state.filterValue &&
        this.props.filterValue !== null
      ) {
        this.setState({
          filterValue: this.props.filterValue
        }, () => {
          this.handleFilterValueChange(this.state.filterValue);

          if (this.props.routerInfo.state.query) {
            let newState = {};
            const query = this.props.routerInfo.state.query;
            if (query.hasOwnProperty('select_count')) {
              newState['unselectedItems'] = Set(query['except_address_ids']);
              newState['selectedItems'] = Set(query['address_ids']);
              newState['selectCount'] = query['select_count'];
              newState['isSelectAll'] = true;
              newState['sortType'] = query['sort_type'];
            } else {
              newState['selectedItems'] = Set(query['address_ids']);
              newState['sortType'] = query['sort_type'];
              newState['isSelectAll'] = false;
            }

            this.setState(newState);
          }
        });

        this.props.storeFilterValue(null);
      } else {
        this.getAddresses(this.props)(query, AddressBookTab.ALL, overwrite);
      }
    }

    this.props.getUserInfo();
    this.props.getSalesforceConfig();
    this.props.getAddressTags();
    this.props.getAddressImportHistoryTags();
    this.props.getAddressTotals();
    this.props.getAddressCorporationDifferencesCount();
    this.props.getSalesforceSyncLastUpdate();
    this.props.getLetterOrderList({
      is_own: 'false',
      except_letter_order_addresses: 'true'
    });
    this.props.getFollowCallOrderList({
      is_own: 'false',
      is_exe: 'false',
      with_ownership_user: 'true',
    });

    this.setState({
      filteredItems: this.filterItems(this.props),
      showInfoBox: this.props.cookies.get('showHouseListInfobox') === '0' ? false : !!this.props.syncCount
    })

    const interval = 20000;
    this.autoSaveInterval = setInterval(() => { this.props.getFailedLinkAddress() }, interval)
  }

  componentWillUnmount() {
    clearInterval(this.autoSaveInterval);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMixedAddresses === false && this.props.isMixedAddresses === true) {
      // 会社宛と会社個人宛の注文があった場合ダイアログを表示
      this.setState({
        showOrderDisableDialog: true,
      });
    }

    if (
      this.props.hasLetterOrderHistoryNames !== prevProps.hasLetterOrderHistoryNames ||
      this.props.duplicateNames !== prevProps.duplicateNames
    ) {
      if (
        this.props.hasLetterOrderHistoryNames.length ||
        this.props.duplicateNames.length
      ) {
        // 過去に注文があった場合ダイアログを表示
        this.confirmSendLetterDialogSet(this.props.hasLetterOrderHistoryNames, this.props.duplicateNames);
      } else {
        this.handleSendLetter();
      }
    }

    if (this.props.orderedFollowCallNames !== prevProps.orderedFollowCallNames) {
      if (this.props.orderedFollowCallNames.length) {
        // 一週間以内の注文があった場合ダイアログを表示
        this.confirmOrderedFollowCallDialogSet();
      } else {
        this.setState({
          showSubmitFollowCallOrderDialog: true,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.addressItems !== nextProps.addressItems ||
      this.props.errorItems !== nextProps.errorItems ||
      this.props.warningItems !== nextProps.warningItems) {
      this.setState({
        filteredItems: this.filterItems(nextProps)
      })
    }

    if (this.props.showDemoData !== nextProps.showDemoData) {
      let query = { 'paging': 1, 'page': 1, 'per_page': ADDRESS_PER_PAGE };
      let overwrite = true;
      if (nextProps.showDemoData) {
        nextProps.goTo('/house-list/main')
      }

      if (nextProps.type === HouseListDirectory.ERROR.name) {
        nextProps.getErrorAddress(query, overwrite);
      } else if (nextProps.type === HouseListDirectory.WARNING.name) {
        nextProps.getWarningAddress(query, overwrite);
      } else if (nextProps.type === HouseListDirectory.NG_LIST.name) {
        nextProps.getNgSendings(query, overwrite);
      } else {
        this.getAddresses(nextProps)(query, AddressBookTab.ALL, overwrite);
      }
    }

    if (nextProps.successMessage && nextProps.successMessage !== '') {
      this.displayNotification(nextProps.successMessage, "success", nextProps.undoable);
    } else if (nextProps.errorMessage && nextProps.errorMessage !== '') {
      this.displayNotification(nextProps.errorMessage, "error", nextProps.undoable);
    } else if (nextProps.shortMessage && nextProps.shortMessage !== '') {
      this.displayNotification(nextProps.shortMessage, "green", nextProps.undoable);
    }

    if ((this.props.isDeleting && nextProps.isDeleting === false) ||
      (this.props.isSaving && nextProps.isSaving === false) ||
      (this.props.isPutting && nextProps.isPutting === false) ||
      (this.props.isUpdatingTags && nextProps.isUpdatingTags === false) ||
      (this.props.isVerifying && nextProps.isVerifying === false) ||
      (this.props.isDeletingAddressTags && !nextProps.isDeletingAddressTags) ||
      (this.props.isUpdatingAddressTags && !nextProps.isUpdatingAddressTags) ||
      (this.props.isUpdatingDifferences && nextProps.isUpdatingDifferences === false) ||
      (this.props.isOverwritingWarningAddress && nextProps.isOverwritingWarningAddress === false) ||
      (this.props.isPostWarningAddressWithExecutivePerson && nextProps.isPostWarningAddressWithExecutivePerson === false) ||
      (this.props.isImporting && nextProps.isImporting === false)) {
      this.handleFilterValueChange(this.state.filterValue);

      this.props.getAddressTotals();

      this.props.getAddressTags();
      this.props.getAddressImportHistoryTags();
      this.props.getAddressCorporationDifferencesCount();

      this.setState({
        selectedItems: Set(),
        unselectedItems: Set(),
        isSelectAll: false,
        selectCount: 0,
      });
    }

    if (this.props.isImporting && nextProps.isImporting === false) {
      this.props.getUserInfo();
      this.setState({
        showInfoBox: nextProps.cookies.get('showHouseListInfobox') === '0' ? false : !!nextProps.syncCount
      })
    }

    if (nextProps.overwrite && this.getCurrentTabLoading(nextProps)) {
      document.body.style.cursor = "progress";
    } else {
      document.body.style.cursor = "auto";
    }

    if (this.props.isLoadingNgList && nextProps.isLoadingNgList === false && this.state.filterValue.search !== '') {
      this.setState({ showSearchNotification: true })
    } else if (this.props.isLoadingNgList && nextProps.isLoadingNgList === false && this.state.filterValue.search === '') {
      this.setState({ showSearchNotification: false })
    }

    if (this.props.type !== nextProps.type) {
      let query = { 'paging': 1, 'page': 1, 'per_page': ADDRESS_PER_PAGE };
      let overwrite = true;
      //nextProps.clearAddressData();

      if (nextProps.type === HouseListDirectory.ERROR.name) {
        this.setState({
          sortType: ErrorAddressSortType.SORT_TYPE_CREATED_AT_DESC.value,
        })
        nextProps.getErrorAddress(query, overwrite);
      } else if (nextProps.type === HouseListDirectory.WARNING.name) {
        this.setState({
          sortType: WarningAddressSortType.SORT_TYPE_CREATED_AT_DESC.value,
        })
        nextProps.getWarningAddress(query, overwrite);
      } else if (nextProps.type === HouseListDirectory.NG_LIST.name) {
        nextProps.getNgSendings(query, overwrite);
      } else {
        this.setState({
          sortType: HouseListSortType.SORT_TYPE_CREATED_AT_DESC.value,
        })
        this.getAddresses(nextProps)(query, AddressBookTab.ALL, overwrite);
      }

      this.setState({
        selectedItems: Set(),
        unselectedItems: Set(),
        isSelectAll: false,
        selectCount: 0,
        showScrollBtn: false,
      });
    }

    if (this.state.isSidebarLoaded === false && this.props.isLoadingSidebar && nextProps.isLoadingSidebar === 0) {
      this.setState({ isSidebarLoaded: true });

      this.props.getUserInfo();
      this.props.getFailedLinkAddress();
      this.props.getExecutiveList({ 'exclude_retirement': [true], 'page': 1, 'per_page': 0, 'paging': 1 })
    }

    //リストをおバーライト場合は、トップに戻る
    if (this.props.overwrite !== nextProps.overwrite) {
      this.scrollToTop();
    }

    if (this.props.failedLinkCorporationCount !== nextProps.failedLinkCorporationCount) {
      this.getCookies('showCorporateNumberWarning', true);
    }
  }

  /*** handler functions ***/
  handleCsvExportAll = () => {
    if (window.confirm(`${this.props.type}のアドレスを全件エクスポートします。よろしいですか？`)) {
      let query = {};
      let path = 'addresses/csv';

      if (this.props.type === HouseListDirectory.ERROR.name) {
        path = 'error-addresses/csv'
      } else if (this.props.type === HouseListDirectory.WARNING.name) {
        path = 'warning-addresses/csv'
      } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
        path = 'ng-sendings/csv';
      } else {
        path = 'addresses/csv';
      }

      query['filename'] = "keyman-letter-house-list";

      let url = URI(process.env.REACT_APP_API_BASE_URL + path);
      url = url.query(query);
      window.open(url);
    }
  }

  handleFilterAddressWithoutCorp = () => {
    let filterValue = this.state.filterValue;
    let link_corporation_status = filterValue['link_corporation_status'];
    //紐付け失敗のチェックを入れる, 3: 紐付け失敗のアイテム
    //他のフィルタをクリア
    this.handleFilterValueChange({ ...this.initialState.filterValue, link_corporation_status: link_corporation_status.add("3") });
  }

  handleFilterAddressCorporationDiff = (type) => {
    let difference_type = Set();
    this.handleFilterValueChange({ ...this.initialState.filterValue, difference_type: difference_type.add(type) });
  }

  handleVerify = () => {
    if (this.props.limitUsage || this.props.showDemoData) {
      this.togglePlanDialog();
    } else {
      if (window.confirm("登記簿との照合を開始します。よろしいですか？")) {
        this.setCookies('showAddressDiffWarning', true);
        this.setCookies('showCompanyNameDiffWarning', true);
        this.setCookies('showCloseWarning', true);
        this.props.postAddressCorporationDifferencesVerify();
      }
    }
  }

  handleUpdateDifferences = (type) => () => {
    let message = ''
    switch (type) {
      case DifferenceType.COMPANY_NAME:
        message = '会社名をすべて更新します。よろしいですか？';
        break;
      case DifferenceType.ADDRESS:
        message = '住所をすべて更新します。よろしいですか？';
        break;
      case DifferenceType.CLOSE:
        message = 'アドレスをすべて削除します。よろしいですか？';
        break;
      default:
    }

    if (window.confirm(message)) {
      this.props.postAddressCorporationDifferencesUpdateDifference({ "type": type });
    }
  }

  handleCsvExport = () => {
    let path = 'addresses/csv';
    let query = this.filterValueToQuery(this.state.filterValue, true);

    let selectedItemsArray = this.state.selectedItems.toArray();
    let unselectedItemsArray = this.state.unselectedItems.toArray();

    if (this.props.type === HouseListDirectory.ERROR.name) {
      path = 'error-addresses/csv'
      if (this.state.isSelectAll) {
        query = {
          ...query,
          "except_error_address_ids": unselectedItemsArray,
          "error_address_ids": selectedItemsArray,
          "select_count": this.state.selectCount,
        };
      } else {
        query = { ...query, "error_address_ids": selectedItemsArray }
      }
    } else if (this.props.type === HouseListDirectory.WARNING.name) {
      path = 'warning-addresses/csv'
      if (this.state.isSelectAll) {
        query = {
          ...query,
          "except_warning_address_ids": unselectedItemsArray,
          "warning_address_ids": selectedItemsArray,
          "select_count": this.state.selectCount,
        };
      } else {
        query = { ...query, "warning_address_ids": selectedItemsArray }
      }
    } else if (this.props.type === HouseListDirectory.MAIN.name) {
      if (this.state.isSelectAll) {
        query = {
          ...query,
          "except_address_ids": unselectedItemsArray,
          "address_ids": selectedItemsArray,
          "select_count": this.state.selectCount,
        };
      } else {
        query = { ...query, "address_ids": selectedItemsArray }
      }

      path = 'addresses/csv';
    } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
      path = 'ng-sendings/csv';
      if (this.state.isSelectAll) {
        query = {
          ...query,
          "except_ng_sending_ids": unselectedItemsArray,
          "ng_sending_ids": selectedItemsArray,
          "select_count": this.state.selectCount,
        };
      } else {
        query = { ...query, "ng_sending_ids": selectedItemsArray }
      }
    }

    query['filename'] = "keyman-letter-house-list";

    let url = URI(process.env.REACT_APP_API_BASE_URL + path);
    url = url.query(qs.stringify(query, { encode: false, arrayFormat: 'indices' }));
    window.open(url);
  }

  handleSave = (editedItems, type, isFollowCallAddress, linkCorporation) => {
    //【refs#3290】ハイフンの置き換えは一旦保留で
    //editedItems[0]['address'] = toHalfWidthHyphen(editedItems[0]['address']);
    if (type === DialogType.CREATE) {
      this.props.addItems({ "addresses": editedItems.map(item => AddressBookUtil.makeAddress(item)), "link_corporation": linkCorporation, "is_follow_call_address": isFollowCallAddress });
    } else if (type === DialogType.EDIT) {
      this.props.editAddress(editedItems);
    } else if (type === DialogType.ERROR) {
      this.props.postErrorAddress(editedItems[0]);
    } else if (type === DialogType.WARNING || type === DialogType.WARNING_DETAIL) {
      this.props.postWarningAddress(editedItems[0]);
    }
  };

  handleUpload = (items, linkCorporation, isFollowCallAddress, import_history_tags = []) => {
    this.props.addItemsFromExcel({ "addresses": items, "link_corporation": linkCorporation, "is_follow_call_address": isFollowCallAddress, "import_history_tags": import_history_tags });
  };

  handleSelectAll = (checked) => {
    this.setState({
      isSelectAll: checked,
      selectedItems: Set(),
      unselectedItems: Set(),
      selectCount: checked ? this.getCurrentTabFilteredTotal() : 0,
    })
  }

  handleSelectItem = (item, key, checked) => {
    let { unselectedItems, selectedItems, selectCount, isSelectAll } = this.state;
    let checkedItem = false;

    if (isSelectAll) {
      checkedItem = key < selectCount;
    }

    if (checkedItem) {
      if (checked) {
        unselectedItems = this.state.unselectedItems.delete(item.id);
      } else {
        unselectedItems = this.state.unselectedItems.add(item.id);
      }
    } else {
      if (checked) {
        selectedItems = this.state.selectedItems.add(item.id);
      } else {
        selectedItems = this.state.selectedItems.delete(item.id);
      }
    }

    if (this.state.selectCount - unselectedItems.count() + selectedItems.count() === 0) {
      this.setState({
        isSelectAll: false,
        selectCount: 0,
      })
    }

    this.setState({
      unselectedItems: unselectedItems,
      selectedItems: selectedItems,
    })
  }

  handleSetSelectOption = (state) => {
    if (state.selectCount > 0 && state.selectCount <= this.getCurrentTabFilteredTotal()) {
      this.setState({
        selectCount: state.selectCount,
        isSelectAll: true,
        selectedItems: Set(),
        unselectedItems: Set(),
      });
    } else {
      this.setState({
        selectCount: 0,
        isSelectAll: false,
        selectedItems: Set(),
        unselectedItems: Set(),
      });
    }
  }

  confirmSendLetter = () => {
    let query = this.filterValueToQuery(this.state.filterValue, true)
    if (this.state.isSelectAll) {
      query['except_address_ids'] = this.state.unselectedItems.toArray();
      query['address_ids'] = this.state.selectedItems.toArray();
      query['select_count'] = this.state.selectCount;
    } else {
      query['address_ids'] = this.state.selectedItems.toArray();
    }
    // フォローコールアドレスが含まれているかどうかを確認する
    query['is_check_follow_call_address'] = true;

    // レター注文前に宛先情報を確認する
    this.props.getSendAddressesConfirm(query)
  }

  confirmOrderedFollowCall = (item = null) => {
    let query = this.filterValueToQuery(this.state.filterValue, true)

    if (item) {
      if (item.follow_call_orders.length) {
        this.setState({
          followCallOrderItem: item,
          showConfirmFollowCallOrderDialog: true,
          modalMessage: item.name ? item.name : item.company + '様'
        });
      } else {
        this.setState({
          followCallOrderItem: item,
          showSubmitFollowCallOrderDialog: true,
        });
      }
    } else {
      this.setState({
        followCallOrderItem: null,
      });
      if (this.state.isSelectAll) {
        query['except_address_ids'] = this.state.unselectedItems.toArray();
        query['address_ids'] = this.state.selectedItems.toArray();
        query['select_count'] = this.state.selectCount;
      } else {
        query['address_ids'] = this.state.selectedItems.toArray();
      }

      // フォローコール注文前に宛先情報を確認する
      this.props.getOrderedFollowCallConfirm(query)
    }
  }

  confirmSendLetterDialogSet = (hasLetterOrderHistoryNames, duplicateNames, selectItem = null) => {
    this.setState({
      letterOrderItem: selectItem ? selectItem : null,
      showConfirmSendDialog: true,
      hasLetterOrderHistoryNames: selectItem ? [selectItem.name] : hasLetterOrderHistoryNames,
      duplicateNames: selectItem ? [] : duplicateNames,  // キーマンを選択した場合は1通なので、注文内で重複はない
    });
  }

  confirmOrderedFollowCallDialogSet = () => {
    let joinOrderedFollowCallNames = "";
    if (this.props.orderedFollowCallNames.length > ADDRESS_NAME_PREVIEW_LIMIT) {
      joinOrderedFollowCallNames = this.props.orderedFollowCallNames.splice(0, ADDRESS_NAME_PREVIEW_LIMIT).join("様, ") + "様...他";
    } else {
      joinOrderedFollowCallNames = this.props.orderedFollowCallNames.join("様, ") + "様";
    }
    this.setState({
      followCallOrderItem: null,
      showConfirmFollowCallOrderDialog: true,
      modalMessage: joinOrderedFollowCallNames,
    });
  }

  handleSingleSendLetter = () => {
    this.props.goTo(`/send-letter`, {
      address_id: this.state.letterOrderItem.id,
      isExe: false,
      filterValue: this.state.filterValue,
    });
  }

  handleSendLetter = (item = null) => {
    let query = this.filterValueToQuery(this.state.filterValue, true);

    this.props.storeFilterValue(this.state.filterValue);

    if (item) {
      let hasLetterOrder = false;
      if (item.letter_orders.length) {
        const itemDates = item.letter_orders.map(item => item.instructed_at);
        let now = new Date();
        const dayCountAtWeek = 7;
        let sevenDaysAgo = now.setDate(now.getDate() - dayCountAtWeek);
        for (var i = 0; i < itemDates.length; i++) {
          let itemDate = new Date(itemDates[i]);
          if (itemDate.getTime() > sevenDaysAgo) {
            hasLetterOrder = true;
            break;
          }
        }
        // 注文確認で警告項目があればダイアログを表示
        if (hasLetterOrder) {
          this.confirmSendLetterDialogSet([], [], item);
        }
      }
      if (!item.letter_orders.length || !hasLetterOrder) {
        this.props.goTo(`/send-letter`, {
          address_id: item.id,
          isExe: false,
          filterValue: this.state.filterValue,
        });
      }
    } else {
      if (this.state.isSelectAll) {
        query['except_address_ids'] = this.state.unselectedItems.toArray();
        query['address_ids'] = this.state.selectedItems.toArray();
        query['select_count'] = this.state.selectCount;
      } else {
        query['address_ids'] = this.state.selectedItems.toArray();
      }

      this.props.goTo(`/send-letter`, {
        query: query,
        ids: this.getSelectedItemIds()(1),
        count: this.getSelectedCount(),
        isExe: false,
        filterValue: this.state.filterValue,
      });
    }
  };

  handleFollowCallOrder = (formParams, item = null) => {
    let query = {};
    if (item) {
      query['address_ids'] = [item.id];
    } else {
      query = this.filterValueToQuery(this.state.filterValue, true);
      if (this.state.isSelectAll) {
        query['except_address_ids'] = this.state.unselectedItems.toArray();
        query['address_ids'] = this.state.selectedItems.toArray();
        query['select_count'] = this.state.selectCount;
      } else {
        query['address_ids'] = this.state.selectedItems.toArray();
      }
      this.props.storeFilterValue(this.state.filterValue);
    }

    const formData = new FormData();

    for (let key in query) {
      if (typeof query[key] === "object") {
        formData.append(
          key,
          JSON.stringify(query[key])
        );
      } else {
        formData.append(key, query[key]);
      }
    }


    for (let key in formParams) {
      if (typeof formParams[key] === "object") {
        formData.append(
          key,
          JSON.stringify(formParams[key])
        );
      } else {
        formData.append(key, formParams[key]);
      }
    }

    const param = {
      data: formData,
      id: item ? item.id : null,
    }

    this.props.postFollowCallOrdersOrder({
      ...param
    });
  };

  handleSortTypeChange = (sortType) => {
    this.setState({
      sortType: sortType
    }, () => this.handleFilterValueChange(this.state.filterValue));
  }

  handleMoveNgSendings = (item) => {
    if (item) {
      if (item.corporation === null || item.link_corporation_status !== LinkCorporationStatusType.LINK_SUCCESS) {
        this.displayNotification(ERR_MOVE_NG_SENDINGS_NO_CORPORATE_NUM, "ghost");
      } else {
        this.props.postAddressesMoveNgSendings({ 'address_ids': [item.id] });
      }
    } else {
      let query = this.filterValueToQuery(this.state.filterValue, true);
      if (this.state.isSelectAll) {
        this.props.postAddressesMoveNgSendings({
          ...query,
          'except_address_ids': this.state.unselectedItems.toArray(),
          'address_ids': this.state.selectedItems.toArray(),
          "select_count": this.state.selectCount,
        });
      } else {
        this.props.postAddressesMoveNgSendings({ ...query, 'address_ids': this.state.selectedItems.toArray() });
      }
    }
  }

  handleDelete = (item) => {
    let selectedItemsArray = this.state.selectedItems.toArray();
    let unselectedItemsArray = this.state.unselectedItems.toArray();
    const { isSelectAll } = this.state;

    if (item) {
      if (this.props.type === HouseListDirectory.ERROR.name) {
        this.props.deleteErrorAddressMulti({ 'error_address_ids': [item.id] });
      } else if (this.props.type === HouseListDirectory.WARNING.name) {
        this.props.deleteWarningAddressMulti({ 'warning_address_ids': [item.id] });
      } else {
        this.props.deleteAddressMulti({ 'address_ids': [item.id] });
      }
    } else {
      let query = this.filterValueToQuery(this.state.filterValue, true);

      if (this.props.type === HouseListDirectory.ERROR.name) {
        if (isSelectAll) {
          this.props.deleteErrorAddressMulti({
            ...query,
            'except_error_address_ids': unselectedItemsArray,
            'error_address_ids': selectedItemsArray,
            'select_count': this.state.selectCount,
          });
        } else {
          this.props.deleteErrorAddressMulti({ ...query, 'error_address_ids': selectedItemsArray });
        }
      } else if (this.props.type === HouseListDirectory.WARNING.name) {
        if (isSelectAll) {
          this.props.deleteWarningAddressMulti({
            ...query,
            'except_warning_address_ids': unselectedItemsArray,
            'warning_address_ids': selectedItemsArray,
            'select_count': this.state.selectCount,
          });
        } else {
          this.props.deleteWarningAddressMulti({ ...query, 'warning_address_ids': selectedItemsArray });
        }
      } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
        if (isSelectAll) {
          this.props.deleteNgSendings({
            'except_ng_sending_ids': unselectedItemsArray,
            'ng_sending_ids': selectedItemsArray,
            'select_count': this.state.selectCount,
          });
        } else {
          this.props.deleteNgSendings({ 'ng_sending_ids': selectedItemsArray });
        }
      } else {
        if (isSelectAll) {
          this.props.deleteAddressMulti({
            ...query,
            'except_address_ids': unselectedItemsArray,
            'address_ids': selectedItemsArray,
            'select_count': this.state.selectCount,
          });
        } else {
          this.props.deleteAddressMulti({ ...query, 'address_ids': selectedItemsArray });
        }
      }
    }
  };

  handleRegistWarningAddresses = () => {
    let selectedItemsArray = this.state.selectedItems.toArray();
    let unselectedItemsArray = this.state.unselectedItems.toArray();
    const { isSelectAll } = this.state;
    let query = this.filterValueToQuery(this.state.filterValue, true);

    if (isSelectAll) {
      this.props.postWarningAddressesMulti({
        ...query,
        'except_warning_address_ids': unselectedItemsArray,
        'warning_address_ids': selectedItemsArray,
        'select_count': this.state.selectCount,
      });
    } else {
      this.props.postWarningAddressesMulti({ ...query, 'warning_address_ids': selectedItemsArray });
    }
  }

  handleChipsDelete = (property, label) => {
    let filterValue = { ...this.state.filterValue };

    let entry;
    switch (property) {
      case 'tag':
      case 'import_history_tag':
      case 'link_corporation_status':
      case 'difference_type':
      case 'position':
      case 'branch':
      case 'warning_type':
        filterValue[property] = filterValue[property].remove(label);
        break;
      case 'follow_call_address':
      case 'letter_order_address':
      case 'salesforce_address':
        filterValue[property] = this.initialState.filterValue[property];
        break;
      case 'search':
        filterValue[property] = '';
        break;
      case 'timeline_status': {
        let timelineStatus = filterValue[property];
        if (timelineStatus.has(label.toString())) {
          filterValue['timeline_status'] = timelineStatus.delete(label);
        } else {
          for (let i = 0; i < statusMenu.length; i++) {
            for (let j = 0; j < statusMenu[i].submenu.length; j++) {
              if (label === statusMenu[i].submenu[j].value) {
                let timelineStatusSubmenu = timelineStatus.get(statusMenu[i].value);
                timelineStatusSubmenu = timelineStatusSubmenu.delete(label);

                if (timelineStatusSubmenu.count() === 0) {
                  filterValue[property] = timelineStatus.delete(statusMenu[i].value);
                } else {
                  filterValue[property] = timelineStatus.set(statusMenu[i].value, timelineStatusSubmenu);
                }

                i = timelineStatusSubmenu.length;
                break;
              }
            }
          }
        }
        break;
      }
      case 'sent_status': {
        let sentStatus = filterValue[property];
        if (sentStatus.has(label.toString())) {
          const sentStatusValueName = sentStatusMenu.find(item => item.value === label.toString()).name;
          if (sentStatusValueName === '注文済みキーマンのみを表示') {
            filterValue['sent_only_from'] = '';
            filterValue['sent_only_to'] = '';
          } else if (sentStatusValueName === '注文済みキーマンを除外') {
            filterValue['sent_except_from'] = '';
            filterValue['sent_except_to'] = '';
          }
          filterValue['sent_status'] = sentStatus.delete(label);
        } else {
          for (let i = 0; i < sentStatusMenu.length; i++) {
            // 日付範囲の選択も削除する
            if (sentStatusMenu[i].name === '注文済みキーマンのみを表示') {
              filterValue['sent_only_from'] = '';
              filterValue['sent_only_to'] = '';
            } else if (sentStatusMenu[i].name === '注文済みキーマンを除外') {
              filterValue['sent_except_from'] = '';
              filterValue['sent_except_to'] = '';
            }
            for (let j = 0; j < sentStatusMenu[i].submenu.length; j++) {
              if (label === sentStatusMenu[i].submenu[j].value) {
                let sentStatusSubmenu = sentStatus.get(sentStatusMenu[i].value);
                sentStatusSubmenu = sentStatusSubmenu.delete(label);

                if (sentStatusSubmenu.count() === 0) {
                  filterValue[property] = sentStatus.delete(sentStatusMenu[i].value);
                } else {
                  filterValue[property] = sentStatus.set(sentStatusSubmenu[i].value, sentStatusSubmenu);
                }

                i = sentStatusSubmenu.length;
                break;
              }
            }
          }
        }
        break;
      }
      case 'follow_call_order_status': {
        let followCallOrderStatus = filterValue[property];
        if (followCallOrderStatus.has(label.toString())) {
          const followCallOrderStatusValueName = followCallOrderStatusMenu.find(item => item.value === label.toString()).name;
          if (followCallOrderStatusValueName === 'フォローコール依頼済みのみを表示') {
            filterValue['follow_call_order_only_from'] = '';
            filterValue['follow_call_order_only_to'] = '';
          } else if (followCallOrderStatusValueName === 'フォローコール依頼済みを除外') {
            filterValue['follow_call_order_except_from'] = '';
            filterValue['follow_call_order_except_to'] = '';
          }
          filterValue['follow_call_order_status'] = followCallOrderStatus.delete(label);
        } else {
          for (let i = 0; i < followCallOrderStatusMenu.length; i++) {
            // 日付範囲の選択も削除する
            if (followCallOrderStatusMenu[i].name === 'フォローコール依頼済みのみを表示') {
              filterValue['follow_call_order_only_from'] = '';
              filterValue['follow_call_order_only_to'] = '';
            } else if (followCallOrderStatusMenu[i].name === 'フォローコール依頼済みを除外') {
              filterValue['follow_call_order_except_from'] = '';
              filterValue['follow_call_order_except_to'] = '';
            }
            for (let j = 0; j < followCallOrderStatusMenu[i].submenu.length; j++) {
              if (label === followCallOrderStatusMenu[i].submenu[j].value) {
                let followCallOrderStatusSubmenu = followCallOrderStatus.get(followCallOrderStatusMenu[i].value);
                followCallOrderStatusSubmenu = followCallOrderStatusSubmenu.delete(label);

                if (followCallOrderStatusSubmenu.count() === 0) {
                  filterValue[property] = followCallOrderStatus.delete(followCallOrderStatusMenu[i].value);
                } else {
                  filterValue[property] = followCallOrderStatus.set(followCallOrderStatusSubmenu[i].value, followCallOrderStatusSubmenu);
                }

                i = followCallOrderStatusSubmenu.length;
                break;
              }
            }
          }
        }
        break;
      }
      case 'prefecture_name':
        entry = prefectureValueToEntryMap[label];
        if (entry) {
          let prefecture_name = filterValue[property];
          let submenu = prefecture_name.get(entry.parent);

          submenu = submenu.delete(label);

          if (submenu.count() === 0) {
            filterValue[property] = prefecture_name.delete(entry.parent);
          } else {
            filterValue[property] = prefecture_name.set(entry.parent, submenu);
          }
        }
        break;
      default:
        break;
    }

    this.handleFilterValueChange(filterValue);
  }

  handleUpdateTags = (tags, type = TagType.CUSTOM_TAG) => {
    let query = this.filterValueToQuery(this.state.filterValue, true);

    if (this.state.isSelectAll) {
      this.props.putAddressTagMulti({
        ...query,
        'tags': tags,
        'except_address_ids': this.state.unselectedItems.toArray(),
        'address_ids': this.state.selectedItems.toArray(),
        'select_count': this.state.selectCount,
        'type': type,
      })
    } else {
      this.props.putAddressTagMulti({
        ...query,
        'tags': tags,
        'address_ids': this.state.selectedItems.toArray(),
        'type': type,
      })
    }

    this.props.getAddressTags();
    this.props.getAddressImportHistoryTags();
  }

  handleScroll = () => {
    if (this.addressTableContent && this.addressTableContent.scrollTop) {
      const maxScrollTop = 400;
      const minScrollTop = 200;
      if (!this.state.showScrollBtn && this.addressTableContent.scrollTop > maxScrollTop) {
        this.setState({ showScrollBtn: true });
      } else if (this.state.showScrollBtn && this.addressTableContent.scrollTop <= minScrollTop) {
        this.setState({ showScrollBtn: false });
      }
    }

    const addScroll = 100;
    if (this.addressTableContent && this.addressTableContent.clientHeight + this.addressTableContent.scrollTop + addScroll >= this.addressTableContent.scrollHeight) {
      const { pageInfo_all, pageInfo_error, pageInfo_warning, pageInfo_ngList } = this.props;
      let pageInfo;

      if (this.props.type === HouseListDirectory.ERROR.name) {
        pageInfo = pageInfo_error;
      } else if (this.props.type === HouseListDirectory.WARNING.name) {
        pageInfo = pageInfo_warning;
      } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
        pageInfo = pageInfo_ngList;
      } else {
        pageInfo = pageInfo_all;
      }

      if (pageInfo && pageInfo.current_page < pageInfo.last_page) {
        let filterValue = this.filterValueToQuery(this.state.filterValue, true);
        let { keyword } = filterValue;
        let query = { 'paging': 1, 'page': pageInfo.current_page + 1, 'per_page': ADDRESS_PER_PAGE };
        let overwrite = false;

        if (this.props.type === HouseListDirectory.ERROR.name) {
          this.props.getErrorAddress({ ...query, ...filterValue }, overwrite);
        } else if (this.props.type === HouseListDirectory.WARNING.name) {
          this.props.getWarningAddress({ ...query, ...filterValue }, overwrite)
        } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
          this.props.getNgSendings(keyword ? { ...query, "keyword": keyword } : query, overwrite)
        } else {
          this.getAddresses(this.props)({ ...query, ...filterValue }, AddressBookTab.ALL, overwrite);
        }
      }
    }
  }

  handleFilterValueChange = (filterValue) => {
    this.setState({ filterValue: filterValue });
    let filterValues = this.filterValueToQuery(filterValue, true);
    let { keyword } = filterValues;
    let query = { 'paging': 1, 'page': 1, 'per_page': ADDRESS_PER_PAGE };
    let overwrite = true;

    if (this.props.type === HouseListDirectory.ERROR.name) {
      this.props.getErrorAddress({ ...query, ...filterValues }, overwrite);
    } else if (this.props.type === HouseListDirectory.WARNING.name) {
      this.props.getWarningAddress({ ...query, ...filterValues }, overwrite)
    } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
      this.props.getNgSendings(keyword ? { ...query, "keyword": keyword } : query, overwrite)
    } else {
      if (filterValues && filterValues['difference_type']) {
        filterValues['difference_type'].forEach(type => {
          if (type === DifferenceType.COMPANY_NAME) {
            this.setCookies('showCompanyNameDiffWarning', true);
          } else if (type === DifferenceType.ADDRESS) {
            this.setCookies('showAddressDiffWarning', true);
          } else if (type === DifferenceType.CLOSE) {
            this.setCookies('showCloseWarning', true);
          }
        })
      }

      this.getAddresses(this.props)({ ...query, ...filterValues }, AddressBookTab.ALL, overwrite);
    }

    this.setState({
      selectedItems: Set(),
      unselectedItems: Set(),
      isSelectAll: false,
      selectCount: 0,
    })
  }

  getAddresses = (props) => (data, tab, overwrite) => {
    if (props.showDemoData) {
      props.getAddressesDemo(data, overwrite);
    } else {
      props.getAddress(data, tab, overwrite);
    }
  }

  handleLinkCorporation = () => {
    let query = this.filterValueToQuery(this.state.filterValue, true);

    if (this.state.isSelectAll) {
      this.props.putAddressLinkCorporation({
        ...query,
        'except_address_ids': this.state.unselectedItems.toArray(),
        'address_ids': this.state.selectedItems.toArray(),
        'select_count': this.state.selectCount,
      });
    } else {
      this.props.putAddressLinkCorporation({ ...query, 'address_ids': this.state.selectedItems.toArray() });
    }
  }

  handleChangeSearch = (e) => {
    this.setState({
      filterValue: {
        ...this.state.filterValue,
        search: e.target.value
      }
    })
  }

  handleEnterKeyPressed = (e) => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode) {
      this.handleFilterValueChange(this.state.filterValue);
    }
  }

  handleFocus = (e) => {
    this.setState({
      prevSearch: e.target.value,
    })
  }

  handleBlur = () => {
    if (this.state.filterValue.search !== this.state.prevSearch) {
      this.handleFilterValueChange(this.state.filterValue);
    }
  }

  /*** toggle functions ***/
  toggleCreateDialog = () => {
    this.setState({ showCreateDialog: !this.state.showCreateDialog });
  }

  toggleCreateFollowCallAddressDialog = () => {
    this.setState({ showCreateFollowCallAddressDialog: !this.state.showCreateFollowCallAddressDialog });
  }

  toggleAddExcelDialog = () => {
    this.setState({ showAddExcelDialog: !this.state.showAddExcelDialog });
  }

  toggleAddFollowCallAddressExcelDialog = () => {
    this.setState({ showAddFollowCallAddressExcelDialog: !this.state.showAddFollowCallAddressExcelDialog });
  }

  toggleDetailDialog = (item) => {
    this.setState({
      showDetailDialog: item ? true : !this.state.showDetailDialog,
      editItems: item ? [item] : this.state.editItems,
    });
  }

  toggleEditDialog = (item) => {
    this.setState({
      showEditDialog: !this.state.showEditDialog,
      editItems: item ? [item] : this.state.editItems,
      showDetailDialog: false,
    });
  }

  toggleFollowCallAddressEditDialog = (item) => {
    this.setState({
      showFollowCallAddressEditDialog: !this.state.showFollowCallAddressEditDialog,
      editItems: item ? [item] : this.state.editItems,
      showDetailDialog: false,
    });
  }

  toggleDeleteDialog = () => {
    this.setState({ showDeleteDialog: !this.state.showDeleteDialog });
  }

  toggleConfirmDialog = () => {
    this.setState({ showConfirmDialog: !this.state.showConfirmDialog });
  }

  toggleAddAddressDialog = () => {
    this.setState({ showAddAddressDialog: !this.state.showAddAddressDialog });
  }

  toggleAddFollowCallAddressDialog = () => {
    this.setState({ showAddFollowCallAddressDialog: !this.state.showAddFollowCallAddressDialog });
  }

  toggleSelectAddAddressDialog = () => {
    this.setState({ showSelectAddAddressDialog: !this.state.showSelectAddAddressDialog });
  }

  togglePlanDialog = () => {
    this.setState({
      showPlanDialog: !this.state.showPlanDialog,
      showDemoDialog: false,
    });
  }

  toggleDemoDialog = () => {
    this.setState({
      showDemoDialog: !this.state.showDemoDialog,
      showPlanDialog: false,
    });
  }

  displayNotification = (message, type, undoable = false) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
      undoable: undoable,
    })
  };

  toggleCreateNgItemDialog = () => {
    this.setState({ showCreateNgItemDialog: !this.state.showCreateNgItemDialog });
  }

  toggleEditNgItemDialog = (item) => {
    this.setState({
      showEditNgItemDialog: !this.state.showEditNgItemDialog,
      editItems: item ? [item] : this.state.editItems,
    });
  }

  toggleInquiryDialog = () => {
    this.setState({
      showInquiryDialog: !this.state.showInquiryDialog,
      showAddAddressDialog: false,
    });
  };

  toggleAddNgExcelDialog = () => {
    this.setState({ showAddNgExcelDialog: !this.state.showAddNgExcelDialog });
  }

  toggleSelectOptionDialog = () => {
    this.setState({ showSelectOptionDialog: !this.state.showSelectOptionDialog });
  }

  toggleManageTagsDialog = () => {
    this.setState({ showManageTagsDialog: !this.state.showManageTagsDialog });
  }

  toggleEditTagsDialog = () => {
    this.setState({ showEditTagsDialog: !this.state.showEditTagsDialog });
  }

  toggleCreateListDialog = () => {
    this.setState({ showCreateListDialog: !this.state.showCreateListDialog });
  }

  toggleInfoBox = () => {
    this.setState({ showInfoBox: !this.state.showInfoBox });
    const intervalYear = 2;
    this.props.cookies.set('showHouseListInfobox', 0, { path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + intervalYear)) });
  }

  toggleConfirmSendDialog = () => {
    this.setState({ showConfirmSendDialog: !this.state.showConfirmSendDialog });
  }

  toggleOrderDisableDialog = () => {
    this.setState({ showOrderDisableDialog: !this.state.showOrderDisableDialog });
  }

  toggleConfirmFollowCallOrderDialog = () => {
    this.setState({ showConfirmFollowCallOrderDialog: !this.state.showConfirmFollowCallOrderDialog });
  }

  toggleSubmitFollowCallOrderDialog = () => {
    this.setState({ showSubmitFollowCallOrderDialog: !this.state.showSubmitFollowCallOrderDialog });
  }

  /*** helper functions ***/
  filterItems = (props) => {
    let currentItems = [];
    if (props.type === HouseListDirectory.MAIN.name) {
      currentItems = props.addressItems;
    } else if (props.type === HouseListDirectory.WARNING.name) {
      currentItems = props.warningItems;
    } else if (props.type === HouseListDirectory.ERROR.name) {
      currentItems = props.errorItems;
    } else if (props.type === HouseListDirectory.NG_LIST.name) {
      currentItems = props.ngList;
    }

    return currentItems;
  }

  selectionToQuery = () => {
    let query = this.filterValueToQuery(this.state.filterValue, true);
    let ids, except_ids;

    if (this.props.type === HouseListDirectory.ERROR.name) {
      ids = 'error_address_ids';
      except_ids = 'except_error_address_ids';
    } else if (this.props.type === HouseListDirectory.WARNING.name) {
      ids = 'warning_address_ids';
      except_ids = 'except_warning_address_ids';
    } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
      ids = 'ng_sending_ids';
      except_ids = 'except_ng_sending_ids';
    } else {
      ids = 'address_ids';
      except_ids = 'except_address_ids';
    }

    if (this.state.isSelectAll) {
      query = {
        ...query,
        [except_ids]: this.state.unselectedItems.toArray(),
        [ids]: this.state.selectedItems.toArray(),
        'select_count': this.state.selectCount,
      }
    } else {
      query = {
        ...query,
        [ids]: this.state.selectedItems.toArray(),
      }
    }

    return query;
  }

  filterValueToQuery = (filterValue, withSortType = true) => {
    let data = {};
    for (let prop in filterValue) {
      switch (prop) {
        case 'branch':
        case 'position':
        case 'tag':
        case 'import_history_tag':
        case 'warning_type':
          if (filterValue[prop].count() > 0) {
            data[prop] = filterValue[prop].toArray();
          }
          break;
        case 'letter_order_address':
        case 'follow_call_address':
        case 'salesforce_address':
          if (filterValue && filterValue[prop]) {
            data[prop] = 1;
          }
          break;
        case 'link_corporation_status':
          if (filterValue[prop].count() > 0) {
            const link_corporation_status = filterValue[prop].toArray();
            data['link_corporation_status'] = link_corporation_status.map(item => parseInt(item, 10));
          }
          break;
        case 'difference_type':
          if (filterValue[prop].count() > 0) {
            const difference_type = filterValue[prop].toArray();
            data['difference_type'] = difference_type.map(item => parseInt(item, 10));
          }
          break;
        case 'search':
          if (filterValue[prop] !== '') {
            data['keyword'] = filterValue[prop];
          }
          break;
        case 'sent_only_from':
        case 'sent_only_to':
        case 'sent_except_from':
        case 'sent_except_to':
        case 'follow_call_order_only_from':
        case 'follow_call_order_only_to':
        case 'follow_call_order_except_from':
        case 'follow_call_order_except_to':
          if (filterValue[prop] !== '') {
            data[prop] = filterValue[prop];
          }
          break;
        case 'prefecture_name':
        case 'timeline_status':
        case 'sent_status':
          if (filterValue[prop].count() > 0) {
            let param = flattenMap(filterValue[prop]);
            if (param.length > 0) {
              data[`${prop}`] = param;
            }
          }
          break;
        case 'follow_call_order_status':
          if (filterValue[prop].count() > 0) {
            let param = flattenMap(filterValue[prop]);
            if (param.length > 0) {
              data[`${prop}`] = param;
            }
          }
          break;
        default:
          break;
      }
    }

    if (withSortType) {
      data['sort_type'] = this.state.sortType;
    }

    return data;
  }

  /***
    * ヘッダーに表示する各タブの件数を表示するため
  ***/
  getCurrentTabTotal = (type) => {
    let { totalAddresses, totalWarningAddresses, totalErrorAddresses, totalNgList } = this.props;

    let currType = type ? type : this.props.type;

    let total;
    if (currType === HouseListDirectory.ERROR.name) {
      total = totalErrorAddresses;
    } else if (currType === HouseListDirectory.WARNING.name) {
      total = totalWarningAddresses;
    } else if (currType === HouseListDirectory.MAIN.name) {
      total = totalAddresses;
    } else if (currType === HouseListDirectory.NG_LIST.name) {
      total = totalNgList;
    }

    return total ? total : this.getCurrentTabFilteredTotal(currType);
  }

  /***
    *  AddressTableに条件絞り込み結果の件数を表示するため
  ***/
  getCurrentTabFilteredTotal = (type) => {
    let { pageInfo_warning, pageInfo_error, pageInfo_all, pageInfo_ngList } = this.props;

    let currType = type ? type : this.props.type;

    if (currType === HouseListDirectory.ERROR.name) {
      return pageInfo_error ? pageInfo_error.total : 0;
    } else if (currType === HouseListDirectory.WARNING.name) {
      return pageInfo_warning ? pageInfo_warning.total : 0;
    } else if (currType === HouseListDirectory.MAIN.name) {
      return pageInfo_all ? pageInfo_all.total : 0;
    } else if (currType === HouseListDirectory.NG_LIST.name) {
      return pageInfo_ngList ? pageInfo_ngList.total : 0;
    }

    return 0;
  }

  getCurrentTabLoading = (properties) => {
    let props = properties ? properties : this.props;
    let isCurrentTabLoading = false;

    if (props.type === HouseListDirectory.ERROR.name) {
      isCurrentTabLoading = props.isLoadingErrorAddress;
    } else if (props.type === HouseListDirectory.WARNING.name) {
      isCurrentTabLoading = props.isLoadingWarningAddress;
    } else if (props.type === HouseListDirectory.NG_LIST.name) {
      isCurrentTabLoading = props.isLoadingNgList;
    } else {
      isCurrentTabLoading = props.isLoading;
    }

    return isCurrentTabLoading;
  }

  getSelectedCount = () => {
    if (this.state.isSelectAll) {
      return this.state.selectCount - this.state.unselectedItems.count() + this.state.selectedItems.count();
    } else {
      return this.state.selectedItems.count();
    }
  }

  setAddressTableContent = (node) => {
    this.addressTableContent = node;
    if (this.addressTableContent) {
      this.addressTableContent.addEventListener('scroll', this.handleScroll, false);
    }
  }

  resetContainer = () => {
    if (this.addressTableContent) {
      this.addressTableContent.scrollTop = 0;
    }

    this.setState({
      filterValue: this.initialState.filterValue,
      prevSearch: '',
    })
  }

  clearFilterValues = () => {
    this.handleFilterValueChange(this.initialState.filterValue);

    this.setState({
      filterValue: this.initialState.filterValue,
      prevSearch: '',
    })
  }

  scrollToTop = () => {
    if (this.addressTableContent) {
      this.addressTableContent.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  }

  getCookies = (props, defaultVal) => {
    const { cookies } = this.props;

    if (cookies.get(props) !== undefined) {
      this.setState({ [props]: cookies.get(props) === 'true' });
    } else {
      this.setState({ [props]: defaultVal });
      const intervalYear = 2;
      cookies.set(props, defaultVal, { path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + intervalYear)) });
    }
  }

  setCookies = (props, value) => {
    const { cookies } = this.props;
    const intervalYear = 2;
    cookies.set(props, value, { path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + intervalYear)) });
    this.setState({ [props]: value });
  }

  getSelectedItemIds = () => (count = 1) => {
    let items = [];
    const { addressItems } = this.props;

    if (this.state.isSelectAll) {
      for (let i = 0; i < addressItems.length; i++) {
        if (!this.state.unselectedItems.has(addressItems[i].id)) {
          items.push(addressItems[i]["id"]);
        }

        if (items.length === count) {
          break;
        }
      }
    } else {
      for (let i = 0; i < addressItems.length; i++) {
        if (this.state.selectedItems.has(addressItems[i].id)) {
          items.push(addressItems[i]["id"]);
        }

        if (items.length === count) {
          break;
        }
      }
    }

    return items;
  }

  disableHouselist = () => {
    const { user } = this.props;

    if (user && user.active_plan && !user.active_plan.use_houselist_flag) {
      return true;
    }

    return false;
  }

  /** render functions **/
  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 10000, top: 10, width: '98%', left: '1%' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false })
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : '100%',
          }}
        >
          {(() => {
            if (this.state.undoable && this.props.prevItem) {
              if (this.props.prevItem.hasOwnProperty("address_ids")) {
                return (<span
                  onClick={() => {
                    this.props.postAddressesRestoreNgSendings({ ...this.props.prevItem, "restore_at": moment().format('YYYY-MM-DD HH:mm:ss') })
                  }}
                  className={this.props.classes.linkBtn}> 取り消し</span>)
              } else if (this.props.prevItem.hasOwnProperty("id")) {
                return (<span onClick={() => { this.props.postWarningAddressRestore({ id: this.props.prevItem.id }) }} className={this.props.classes.linkBtn}> 元に戻す </span>)
              }
            }
          })()}
        </NotificationBar>
      </div>
    );
  };

  renderEmptyContent = () => {
    return (
      <NoAddressPage
        user={this.props.user}
        type={this.props.type}
        toggleAddAddressDialog={this.toggleAddAddressDialog}
        disabled={this.disableHouselist()}
        togglePlanDialog={this.togglePlanDialog}
      />
    )
  };

  renderSidebar = () => {
    const { classes, type } = this.props;

    if (type !== HouseListDirectory.NG_LIST.name) {
      return (
        <div className={classes.sidebar}>
          <AddressBookSidebar
            user={this.props.user}
            tags={this.props.tags}
            importHistories={this.props.importHistories}
            disabled={
              (this.getCurrentTabLoading() && this.props.overwrite) ||
              this.disableHouselist()
            }
            isFiltering={this.getCurrentTabLoading()}
            updateFilter={this.handleFilterValueChange}
            filterValue={this.state.filterValue}
            type={this.props.type}
            toggleManageTagsDialog={this.toggleManageTagsDialog}
            isDemo={this.props.showDemoData}
            togglePlanDialog={this.togglePlanDialog}
            lastUpdate={this.props.lastUpdate}
            postSalesforceSync={this.props.postSalesforceSync}
            isImporting={this.props.isImporting}
            letterOrderList={this.props.letterOrderList}
            followCallOrderList={this.props.followCallOrderList}
          />
        </div>
      )
    }
  }

  renderAddAddressDialog = () => {
    return (
      <AddAddressDialog
        user={this.props.user}
        type={this.props.type}
        isOpen={this.state.showAddAddressDialog}
        toggleDialog={this.toggleAddAddressDialog}
        toggleCreateDialog={this.toggleCreateDialog}
        toggleAddExcelDialog={this.toggleAddExcelDialog}
        toggleCreateNgItemDialog={this.toggleCreateNgItemDialog}
        toggleAddNgExcelDialog={this.toggleAddNgExcelDialog}
        toggleInquiryDialog={this.toggleInquiryDialog}
        goTo={this.props.goTo}
      />
    )
  }

  renderAddFollowCallAddressDialog = () => {
    return (
      <AddAddressDialog
        user={this.props.user}
        type={this.props.type}
        isOpen={this.state.showAddFollowCallAddressDialog}
        isFollowCallAddress={true}
        toggleDialog={this.toggleAddFollowCallAddressDialog}
        toggleCreateDialog={this.toggleCreateFollowCallAddressDialog}
        toggleAddExcelDialog={this.toggleAddFollowCallAddressExcelDialog}
        toggleCreateNgItemDialog={this.toggleCreateNgItemDialog}
        toggleAddNgExcelDialog={this.toggleAddNgExcelDialog}
        toggleInquiryDialog={this.toggleInquiryDialog}
        goTo={this.props.goTo}
      />
    )
  }

  renderSelectAddAddressDialog = () => {
    return (
      <SelectAddAddressDialog
        user={this.props.user}
        type={this.props.type}
        isOpen={this.state.showSelectAddAddressDialog}
        toggleDialog={this.toggleSelectAddAddressDialog}
        toggleAddFollowCallAddressDialog={this.toggleAddFollowCallAddressDialog}
        toggleAddAddressDialog={this.toggleAddAddressDialog}
      />
    )
  }

  renderInquiryDialog = () => {
    if (this.state.showInquiryDialog) {
      return (
        <IntegrationInquiryDialog
          isOpen={this.state.showInquiryDialog}
          toggleDialog={this.toggleInquiryDialog}
        />
      );
    }
  };

  renderCreateDialog = () => {
    return (
      <EditAddressDialog
        title="アドレスを新規登録"
        type={DialogType.CREATE}
        isOpen={this.state.showCreateDialog}
        toggleDialog={this.toggleCreateDialog}
        save={this.handleSave}
        isSaving={this.props.isSaving}
        error={this.props.error}
      />);
  }

  renderCreateFollowCallAddressDialog = () => {
    return (
      <EditAddressDialog
        title="フォローコールアドレスを新規登録"
        type={DialogType.CREATE}
        isOpen={this.state.showCreateFollowCallAddressDialog}
        toggleDialog={this.toggleCreateFollowCallAddressDialog}
        save={this.handleSave}
        isSaving={this.props.isSaving}
        error={this.props.error}
        isFollowCallAddress={true}
      />);
  }

  renderAddExcelDialog = () => {
    return (
      <AddFromExcelDialog
        onUpload={this.handleUpload}
        onFinished={this.toggleAddExcelDialog}
        isOpen={this.state.showAddExcelDialog}
        toggleDialog={this.toggleAddExcelDialog}
        displayNotification={this.displayNotification}
      />);
  }

  renderAddFollowCallAddressExcelDialog = () => {
    return (
      <AddFromExcelDialog
        onUpload={this.handleUpload}
        onFinished={this.toggleAddFollowCallAddressExcelDialog}
        isOpen={this.state.showAddFollowCallAddressExcelDialog}
        toggleDialog={this.toggleAddFollowCallAddressExcelDialog}
        displayNotification={this.displayNotification}
        isFollowCallAddress={true}
      />);
  }

  renderAddNgExcelDialog = () => {
    return (
      <AddNgExcelDialog
        isOpen={this.state.showAddNgExcelDialog}
        toggleDialog={this.toggleAddNgExcelDialog}
        postNgSendings={this.props.postNgSendingsExcel}
        displayNotification={this.displayNotification}
      />
    );
  }

  renderCreateNgItemDialog = () => {
    return (
      <EditNgItemDialog
        title="送付NGを新規登録"
        type={DialogType.CREATE}
        isOpen={this.state.showCreateNgItemDialog}
        toggleDialog={this.toggleCreateNgItemDialog}
        postNgSendings={this.props.postNgSendings}
        isSaving={this.props.isSaving}
        error={this.props.error}
      />
    )
  }

  renderManageTagsDialog = () => {
    return (
      <ManageTagsDialog
        title="リストの管理"
        type={TagType.CUSTOM_TAG}
        toggleDialog={this.toggleManageTagsDialog}
        isOpen={this.state.showManageTagsDialog}
        tags={this.props.tags}
        deleteTag={(data) => {
          if (this.props.type === HouseListDirectory.WARNING.name) {
            this.props.putWarningAddressesTagsDeleteMulti(data);
          } else if (this.props.type === HouseListDirectory.ERROR.name) {
            this.props.putErrorAddressesTagsDeleteMulti(data);
          } else {
            this.props.putAddressesTagsDeleteMulti(data);
          }
        }}
        updateTagName={(data) => {
          if (this.props.type === HouseListDirectory.WARNING.name) {
            this.props.putWarningAddressesTagsUpdateTagNameMulti(data);
          } else if (this.props.type === HouseListDirectory.ERROR.name) {
            this.props.putErrorAddressesTagsUpdateTagNameMulti(data);
          } else {
            this.props.putAddressesTagsUpdateTagNameMulti(data);
          }
        }}
        isUpdatingAddressTags={this.props.isUpdatingAddressTags}
        isDeletingAddressTags={this.props.isDeletingAddressTags}
        isLoadingSidebar={!!this.props.isLoadingSidebar}
        updateFilter={val => this.handleFilterValueChange({ ...this.initialState.filterValue, ...val })}
        errorMessage={this.props.errorMessage}
        chipsDelete={this.handleChipsDelete}
      />
    )
  }

  renderDetailDialog = () => {
    let item;
    if (this.state.editItems.length > 0) {
      item = this.state.editItems[0];
    }

    if (item && (item.type === WarningAddressType['DUPLICATE'].value || item.type === WarningAddressType['DUPLICATE_EXECUTIVE_PERSON'].value || item.duplicate_address || item.duplicate_executive_person)) {
      return (
        <DetailDialog
          isOpen={this.state.showDetailDialog}
          onClose={this.toggleDetailDialog}
          item={item}
          remove={this.props.deleteWarningAddressMulti}
          isDeleting={this.props.isDeleting}
          postWarningAddressOverwrite={this.props.postWarningAddressOverwrite}
          isOverwritingWarningAddress={this.props.isOverwritingWarningAddress}
          postWarningAddressWithExecutivePerson={this.props.postWarningAddressWithExecutivePerson}
          isPostWarningAddressWithExecutivePerson={this.props.isPostWarningAddressWithExecutivePerson}
        />
      )
    } else if (item && item.type === WarningAddressType['CONTAINS_SYMBOL'].value) {
      return (
        <EditAddressDialog
          type={DialogType.WARNING_DETAIL}
          item={item}
          isOpen={this.state.showDetailDialog}
          toggleDialog={this.toggleDetailDialog}
          save={this.handleSave}
          delete={this.handleDelete}
          isSaving={this.props.isSaving}
          isDeleting={this.props.isDeleting}
          error={this.props.error}
          getAddressSuggestCorporations={this.props.getAddressSuggestCorporations}
          getWarningAddressSuggestCorp={this.props.getWarningAddressSuggestCorp}
          getErrorAddressSuggestCorp={this.props.getErrorAddressSuggestCorp}
          corporations={this.props.corporations}
          isLoadingCorp={this.props.isLoadingCorp}
        />);
    } else if (item &&
      (item.type === WarningAddressType['ADDRESS_LENGTH'].value ||
        item.type === WarningAddressType['INVALID_POSTCODE'].value ||
        item.type === WarningAddressType['INVALID_ADDRESS_REPEATING_PATTERNS'].value ||
        item.type === WarningAddressType['INVALID_ADDRESS_NOT_MATCHING_POSTCODE_DATA'].value)) {
      return (
        <EditAddressDialog
          title="アドレスを編集"
          type={DialogType.WARNING}
          item={item}
          isOpen={this.state.showDetailDialog}
          toggleDialog={this.toggleDetailDialog}
          save={this.handleSave}
          delete={this.handleDelete}
          isSaving={this.props.isSaving}
          isDeleting={this.props.isDeleting}
          error={this.props.error}
          getAddressSuggestCorporations={this.props.getAddressSuggestCorporations}
          getWarningAddressSuggestCorp={this.props.getWarningAddressSuggestCorp}
          getErrorAddressSuggestCorp={this.props.getErrorAddressSuggestCorp}
          corporations={this.props.corporations}
          isLoadingCorp={this.props.isLoadingCorp}
        />);
    } else {
      return undefined;
    }
  }

  renderEditDialog = () => {
    let type = DialogType.EDIT;
    if (this.props.type === HouseListDirectory.ERROR.name) {
      type = DialogType.ERROR;
    } else if (this.props.type === HouseListDirectory.WARNING.name) {
      type = DialogType.WARNING;
    }

    return (
      <EditAddressDialog
        title="アドレスを編集"
        type={type}
        isOpen={this.state.showEditDialog}
        toggleDialog={this.toggleEditDialog}
        save={this.handleSave}
        delete={this.handleDelete}
        item={this.state.editItems[0]}
        isSaving={this.props.isSaving}
        error={this.props.error}
        getAddressSuggestCorporations={this.props.getAddressSuggestCorporations}
        getWarningAddressSuggestCorp={this.props.getWarningAddressSuggestCorp}
        getErrorAddressSuggestCorp={this.props.getErrorAddressSuggestCorp}
        corporations={this.props.corporations}
        postAddressCorporationDifferencesUpdateDifference={this.props.postAddressCorporationDifferencesUpdateDifference}
        isLoadingCorp={this.props.isLoadingCorp}
        isUpdatingDifferences={this.props.isUpdatingDifferences}
      />);
  };

  renderFollowCallAddressEditDialog = () => {
    let type = DialogType.EDIT;
    if (this.props.type === HouseListDirectory.ERROR.name) {
      type = DialogType.ERROR;
    } else if (this.props.type === HouseListDirectory.WARNING.name) {
      type = DialogType.WARNING;
    }

    return (
      <EditAddressDialog
        title="アドレスを編集"
        type={type}
        isOpen={this.state.showFollowCallAddressEditDialog}
        toggleDialog={this.toggleFollowCallAddressEditDialog}
        save={this.handleSave}
        delete={this.handleDelete}
        item={this.state.editItems[0]}
        isSaving={this.props.isSaving}
        error={this.props.error}
        getAddressSuggestCorporations={this.props.getAddressSuggestCorporations}
        getWarningAddressSuggestCorp={this.props.getWarningAddressSuggestCorp}
        getErrorAddressSuggestCorp={this.props.getErrorAddressSuggestCorp}
        corporations={this.props.corporations}
        postAddressCorporationDifferencesUpdateDifference={this.props.postAddressCorporationDifferencesUpdateDifference}
        isLoadingCorp={this.props.isLoadingCorp}
        isUpdatingDifferences={this.props.isUpdatingDifferences}
        isFollowCallAddress={true}
      />);
  };

  renderEditNgItemDialog = () => {
    return (
      <EditNgItemDialog
        title="送付NGを編集"
        type={DialogType.EDIT}
        item={this.state.editItems[0]}
        isOpen={this.state.showEditNgItemDialog}
        toggleDialog={this.toggleEditNgItemDialog}
        putNgSendings={this.props.putNgSendings}
        isSaving={this.props.isSaving}
        error={this.props.error}
      />);
  }

  renderDeleteDialog = () => {
    return (
      <DeleteDialog
        remove={this.handleDelete}
        title="アドレスを削除"
        isOpen={this.state.showDeleteDialog}
        toggleDialog={this.toggleDeleteDialog}
        isDeleting={this.props.isDeleting}
      />
    );
  };

  renderConfirmDialog = () => {
    return (
      <ConfirmDialog
        action={this.handleRegistWarningAddresses}
        buttonText="登録する"
        isOpen={this.state.showConfirmDialog}
        toggleDialog={this.toggleConfirmDialog}
        isLoading={this.props.isSaving}
      />
    );
  };

  renderSelectOptionDialoog = () => {
    return (
      <SelectOptionDialog
        toggleDialog={this.toggleSelectOptionDialog}
        isOpen={this.state.showSelectOptionDialog}
        totalCount={this.getCurrentTabFilteredTotal()}
        handleSetSelectOption={this.handleSetSelectOption}
      />
    )
  }

  renderEditTagsDialog = () => {
    return (
      <EditTagsDialog
        toggleDialog={this.toggleEditTagsDialog}
        isOpen={this.state.showEditTagsDialog}
        tags={this.props.selectedAddressTags}
        isLoadingSelectedAddressTags={this.props.isLoadingSelectedAddressTags}
        getTags={this.props.getSelectedAddressTags}
        saveTags={this.handleUpdateTags}
        deleteTag={(data) => {
          if (this.props.type === HouseListDirectory.WARNING.name) {
            this.props.putWarningAddressesTagsDeleteMulti(data);
          } else if (this.props.type === HouseListDirectory.ERROR.name) {
            this.props.putErrorAddressesTagsDeleteMulti(data);
          } else {
            this.props.putAddressesTagsDeleteMulti(data);
          }
        }}
        query={this.selectionToQuery()}
        isDeletingAddressTags={this.props.isDeletingAddressTags}
        errorMessage={this.props.errorMessage}
        selectCount={this.getSelectedCount()}
        isUpdatingTags={this.props.isUpdatingTags}
        options={this.props.tags}
        toggleCreateListDialog={this.toggleCreateListDialog}
      />
    )
  }

  renderCreateListDialog = () => {
    return (
      <CreateListDialog
        toggleDialog={this.toggleCreateListDialog}
        isOpen={this.state.showCreateListDialog}
        isUpdatingTags={this.props.isUpdatingTags}
        saveTags={this.handleUpdateTags}
        toggleEditTagsDialog={this.toggleEditTagsDialog}
      />
    )
  }

  renderDemoDialog = () => {
    if (this.state.showDemoDialog) {
      return (
        <DemoDialog
          isOpen={this.state.showDemoDialog}
          toggleDialog={this.toggleDemoDialog}
          togglePlanDialog={this.togglePlanDialog}
          user={this.props.user}
        />
      );
    }
  }

  renderConfirmSendDialog = () => {
    if (this.state.showConfirmSendDialog) {
      return (
        <ConfirmSendDialog
          isOpen={this.state.showConfirmSendDialog}
          toggleDialog={this.toggleConfirmSendDialog}
          duplicateNames={this.state.duplicateNames}
          hasLetterOrderHistoryNames={this.state.hasLetterOrderHistoryNames}
          action={this.state.letterOrderItem ? this.handleSingleSendLetter : this.handleSendLetter}
        />
      );
    }
  }

  renderOrderDisableDialog = () => {
    if (this.state.showOrderDisableDialog) {
      return (
        <OrderDisableDialog
          isOpen={this.state.showOrderDisableDialog}
          toggleDialog={this.toggleOrderDisableDialog}
        />
      );
    }
  }

  renderConfirmFollowCallOrderDialog = () => {
    if (this.state.showConfirmFollowCallOrderDialog) {
      return (
        <ConfirmFollowCallOrderDialog
          isOpen={this.state.showConfirmFollowCallOrderDialog}
          toggleDialog={this.toggleConfirmFollowCallOrderDialog}
          message={this.state.modalMessage}
          action={this.toggleSubmitFollowCallOrderDialog}
        />
      );
    }
  };

  renderSubmitFollowCallOrderDialog = () => {
    if (this.state.showSubmitFollowCallOrderDialog) {
      return (
        <SubmitFollowCallOrderDialog
          isOpen={this.state.showSubmitFollowCallOrderDialog}
          toggleDialog={this.toggleSubmitFollowCallOrderDialog}
          selectedCount={this.state.followCallOrderItem ? 1 : this.getSelectedCount()}
          action={(formParams) => this.handleFollowCallOrder(formParams, this.state.followCallOrderItem ? this.state.followCallOrderItem : null)}
          isPosting={this.props.isPostingFollowCallOrder}
        />
      )
    }
  }

  renderDemoNotification = () => {
    const { classes } = this.props;

    if (this.props.showDemoData) {
      return (
        <div style={{ position: 'fixed', zIndex: 10000, top: 10, left: '50%', transform: 'translateX(-50%)' }}>
          <NotificationBar
            message={<div className={classes.demoNotification}>
              <span>デモを表示しています</span>
              <MuiButton onClick={this.toggleDemoDialog} className={classes.demoButton}>詳細</MuiButton>
            </div>}
            type="yellow"
            open={true}
            autoClose={false}
            style={{
              width: "280px",
              fontWeight: 'normal'
            }}
          >
          </NotificationBar>
        </div>
      );
    }
  }

  renderSalesforceInfoBox = () => {
    if (this.state.showInfoBox) {
      return (
        <SalesforceInfoBox
          isOpen={this.state.showInfoBox}
          toggleDialog={this.toggleInfoBox}
          syncCount={this.props.syncCount}
        />
      )
    }
  }

  renderPlanDialog = () => {
    if (this.state.showPlanDialog) {
      return (
        <PlanDialog
          isOpen={this.state.showPlanDialog}
          toggleDialog={this.togglePlanDialog}
        />
      )
    }
  }

  renderFilterChips = () => {
    const { classes } = this.props;
    let { filterValue } = this.state;
    let chips = [];

    for (let property in filterValue) {
      let label;
      let labels = [];
      switch (property) {
        case 'link_corporation_status':
          if (filterValue[property].count() > 0) {
            const link_corporation_status = filterValue[property].toArray();
            link_corporation_status.forEach(status => {
              label = linkCorporationStatusMenu.find(item => item.value.toString() === status).name;
              labels.push({ name: label, value: status });
            })
          }
          break;
        case 'difference_type':
          if (filterValue[property].count() > 0) {
            const difference_type = filterValue[property].toArray();
            difference_type.forEach(type => {
              label = differenceTypeMenu.find(item => item.value.toString() === type).name;
              labels.push({ name: label, value: type });
            })
          }
          break;
        case 'tag':
        case 'import_history_tag':
          if (filterValue[property].count() > 0) {
            const tags = filterValue[property].toArray();
            tags.forEach(tag => labels.push({ name: tag, value: tag }))
          }
          break;
        case 'search':
          if (filterValue[property] !== '') {
            labels.push({ name: filterValue[property], value: filterValue[property] });
          }
          break;
        case 'prefecture_name':
          if (filterValue[property].count() > 0) {
            let values = flattenMap(filterValue[property]);
            values.forEach(value => {
              labels.push({ name: value, value: value });
            })
          }
          break;
        case 'position':
          if (filterValue[property].count() > 0) {
            const positions = filterValue[property].toArray();
            positions.forEach(status => {
              label = honorificMenu.find(item => item.value.toString() === status).name;
              labels.push({ name: label, value: status });
            })
          }
          break;
        case 'branch':
          if (filterValue[property].count() > 0) {
            const branch = filterValue[property].toArray();
            branch.forEach(status => {
              label = departmentMenu.find(item => item.value.toString() === status).name;
              labels.push({ name: label, value: status });
            })
          }
          break;
        case 'timeline_status':
          if (filterValue[property].count() > 0) {
            let names = flattenMap(filterValue[property], statusMenu, 'name');
            let values = flattenMap(filterValue[property], statusMenu, 'value');

            names.forEach((label, index) => {
              let entry = statusValueToEntryMap[values[index]];
              labels.push({ name: `${entry ? entry.parent_name + " : " + label : label}`, value: values[index], category: 'ステータス', property: property });
            })
          }
          break;
        case 'sent_status':
          if (filterValue[property].count() > 0) {
            let names = flattenMap(filterValue[property], sentStatusMenu, 'name');
            let values = flattenMap(filterValue[property], sentStatusMenu, 'value');

            names.forEach((label, index) => {
              let entry = sentStatusValueToEntryMap[values[index]];
              let rangeDate = '';
              if (
                ((entry && entry.parent_name === '注文済みキーマンのみを表示') || (label === '注文済みキーマンのみを表示')) &&
                filterValue && filterValue.sent_only_from && filterValue.sent_only_to
              ) {
                rangeDate = `（${moment(filterValue.sent_only_from).format('YYYY年MM月DD日')} - ${moment(filterValue.sent_only_to).format('YYYY年MM月DD日')}）`;
              } else if (
                ((entry && entry.parent_name === '注文済みキーマンを除外') || (label === '注文済みキーマンを除外')) &&
                filterValue && filterValue.sent_except_from && filterValue.sent_except_to
              ) {
                rangeDate = `（${moment(filterValue.sent_except_from).format('YYYY年MM月DD日')} - ${moment(filterValue.sent_except_to).format('YYYY年MM月DD日')}）`
              }
              labels.push({ name: `${entry ? entry.parent_name + " : " + label : label}${rangeDate}`, value: values[index], category: '送信ステータス', property: property });
            })
          }
          break;
        case 'follow_call_order_status':
          if (filterValue[property].count() > 0) {
            let names = flattenMap(filterValue[property], followCallOrderStatusMenu, 'name');
            let values = flattenMap(filterValue[property], followCallOrderStatusMenu, 'value');

            names.forEach((label, index) => {
              let entry = followCallOrderStatusValueToEntryMap[values[index]];
              let rangeDate = '';
              if (
                ((entry && entry.parent_name === 'フォローコール依頼済みのみを表示') || (label === 'フォローコール依頼済みのみを表示')) &&
                filterValue && filterValue.follow_call_order_only_from && filterValue.follow_call_order_only_to
              ) {
                rangeDate = `（${moment(filterValue.follow_call_order_only_from).format('YYYY年MM月DD日')} - ${moment(filterValue.follow_call_order_only_to).format('YYYY年MM月DD日')}）`;
              } else if (
                ((entry && entry.parent_name === 'フォローコール依頼済みを除外') || (label === 'フォローコール依頼済みを除外')) &&
                filterValue && filterValue.follow_call_order_except_from && filterValue.follow_call_order_except_to
              ) {
                rangeDate = `（${moment(filterValue.follow_call_order_except_from).format('YYYY年MM月DD日')} - ${moment(filterValue.follow_call_order_except_to).format('YYYY年MM月DD日')}）`
              }
              labels.push({ name: `${entry ? entry.parent_name + " : " + label : label}${rangeDate}`, value: values[index], category: '送信ステータス', property: property });
            })
          }
          break;
        case 'letter_order_address':
        case 'follow_call_address':
        case 'salesforce_address':
          if (filterValue && filterValue[property]) {
            const addressType = {
                "letter_order_address": "レター送付",
                "follow_call_address": "フォローコール",
                "salesforce_address": "Salesforce"
              };
            labels.push({ name: addressType[property] + 'アドレスを表示', value: filterValue[property], property: property })
          }
          break;
        case 'warning_type':
          if (filterValue[property].count() > 0) {
            const warningTypes = filterValue[property].toArray();
            warningTypes.forEach(warningType => {
              label = warningTypeMenu.find(item => item.value.toString() === warningType).name;
              labels.push({ name: label, value: warningType, category: '警告の種類' });
            })
          }
          break;
        default:
          break;
      }

      labels.forEach(label => {
        chips.push(
          <Chip
            key={chips.length}
            label={label.name}
            color="primary"
            classes={{
              root: classes.chipRoot,
              label: classes.chipLabel,
            }}
            onDelete={() => this.handleChipsDelete(property, label.value)}
            deleteIcon={<CancelCircle width={15} height={15} color="#6F9EFF" />}
          />
        )
      });
    }

    if (chips.length > 0) {
      return (
        <div className={classes.chipContainer}>
          <Typography variant="body1">絞り込み条件</Typography>
          {chips}
          <Button
            text="絞り込み条件をリセット"
            type="ghost"
            size="extra-small"
            handleClickButton={this.clearFilterValues}
            style={{
              color: '#71737B',
              border: 'none',
              width: 'unset',
              padding: '0px 5px',
              textDecoration: 'underline',
              marginTop: '8px',
              marginRight: '10px',
              minWidth: '140px',
              float: 'left'
            }}
          />
        </div>
      )
    }
  }

  renderWarningMessage = () => {
    const { classes, failedLinkCorporationCount, addressCorporationDifferencesCount } = this.props;
    const { showCorporateNumberWarning, showAddressDiffWarning,
      showCompanyNameDiffWarning, showCloseWarning } = this.state;

    if (this.props.type === HouseListDirectory.MAIN.name) {
      return (
        <div className={classes.warningMessage}>
          {failedLinkCorporationCount > 0 && showCorporateNumberWarning && (
            <WarningLabel
              text={`${failedLinkCorporationCount}件の法人番号を確認してください`}
              Icon={Exclamation}
              style={{ margin: '0px 12px 12px 0px', float: 'left' }}
              onClick={this.handleFilterAddressWithoutCorp}
              onClose={() => this.setCookies('showCorporateNumberWarning', false)}
            />
          )}

          {addressCorporationDifferencesCount.diff_address_count > 0 && showAddressDiffWarning && (
            <WarningLabel
              text={`${addressCorporationDifferencesCount.diff_address_count}件の住所が登記簿上で変更されました`}
              Icon={Exclamation}
              style={{ margin: '0px 12px 12px 0px', float: 'left' }}
              onClick={() => this.handleFilterAddressCorporationDiff(DifferenceType.ADDRESS.toString())}
              controls={[
                { text: 'すべて更新', func: this.handleUpdateDifferences(DifferenceType.ADDRESS) },
              ]}
              onClose={() => this.setCookies('showAddressDiffWarning', false)}
            />
          )}

          {addressCorporationDifferencesCount.diff_company_name_count > 0 && showCompanyNameDiffWarning && (
            <WarningLabel
              text={`${addressCorporationDifferencesCount.diff_company_name_count}件の会社名が登記簿上で変更されました`}
              Icon={Exclamation}
              style={{ margin: '0px 12px 12px 0px', float: 'left' }}
              onClick={() => this.handleFilterAddressCorporationDiff(DifferenceType.COMPANY_NAME.toString())}
              controls={[
                { text: 'すべて更新', func: this.handleUpdateDifferences(DifferenceType.COMPANY_NAME) },
              ]}
              onClose={() => this.setCookies('showCompanyNameDiffWarning', false)}
            />
          )}

          {addressCorporationDifferencesCount.close_count > 0 && showCloseWarning && (
            <WarningLabel
              text={`${addressCorporationDifferencesCount.close_count}件の会社が閉鎖されました`}
              Icon={Exclamation}
              style={{ margin: '0px 12px 12px 0px', float: 'left' }}
              onClick={() => this.handleFilterAddressCorporationDiff(DifferenceType.CLOSE.toString())}
              controls={[
                { text: 'すべて削除', func: this.handleUpdateDifferences(DifferenceType.CLOSE) },
              ]}
              onClose={() => this.setCookies('showCloseWarning', false)}
            />
          )}
        </div>
      )
    }
  }

  renderMainPanelHeader = () => {
    const { classes, type, pageInfo_all, pageInfo_error, pageInfo_warning } = this.props;

    if (type !== HouseListDirectory.NG_LIST.name) {
      let total = 0;
      if (type === HouseListDirectory.MAIN.name) {
        total = pageInfo_all ? pageInfo_all.total : 0;
      } else if (type === HouseListDirectory.WARNING.name) {
        total = pageInfo_warning ? pageInfo_warning.total : 0;
      } else if (type === HouseListDirectory.ERROR.name) {
        total = pageInfo_error ? pageInfo_error.total : 0;
      }

      return (
        <div className={classes.addressTableHeader}>
          <div className={classes.totalCount}>
            <Typography variant="body1">該当するアドレス</Typography>
            <Typography variant="display2" style={{ marginTop: '8px', lineHeight: '37px' }}>{addCommas(total)}件</Typography>
          </div>
          {this.renderFilterChips()}
          <div style={{ flex: 1 }}></div>
          {(type === HouseListDirectory.MAIN.name && isEnabledUserRole(this.props.user, "house-list", "edit")) && (<div className={classes.totalCount}>
            <Typography variant="body1">登記簿と照合</Typography>
            <Button
              text="照合を開始"
              type="ghost"
              size="small"
              handleClickButton={this.handleVerify}
              disabled={this.props.isVerifying}
              style={{
                width: 'unset',
                padding: '0px 5px',
                marginTop: '8px',
                border: '#D8DBDF 1px solid',
                background: 'transparent',
              }}
            />
          </div>)}
        </div>
      )
    } else {
      return (
        <div className={classes.ngListSearchBar}>
          <TextField
            id="search"
            type="search"
            placeholder="会社名、氏名などで検索"
            value={this.state.filterValue.search}
            onChange={this.handleChangeSearch}
            onKeyDown={this.handleEnterKeyPressed}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            InputProps={{
              disableUnderline: true,
              startAdornment: <InputAdornment position="start"><Search style={{ fill: '#71737B' }} /></InputAdornment>,
              classes: {
                root: classes.ngListSearchRoot,
                input: classes.ngListSearchInput,
              }
            }}
          />
        </div>
      )
    }
  }

  renderSearchNotification = () => {
    const { pageInfo_ngList, type, classes } = this.props;

    if (type === HouseListDirectory.NG_LIST.name && this.state.showSearchNotification) {
      let message = `${pageInfo_ngList.total}件該当しました`;

      return (
        <div className={classes.searchNotifContainer}>
          <NotificationBar
            open={true}
            message={message}
            type={pageInfo_ngList.total.length === 0 ? "ghost" : "success"}
            autoClose={false}
            animation="none"
            disableOnclickListener={true}
            style={{ transform: 'none', boxShadow: 'none', width: '100%', boxSizing: 'border-box', marginBottom: '20px' }}
          />
        </div>
      )
    }
  }

  renderAddressTable = () => {
    const { classes, type } = this.props;

    let addressTable;
    if (type === HouseListDirectory.MAIN.name) {
      addressTable = this.renderMainTable()
    } else if (type === HouseListDirectory.WARNING.name) {
      addressTable = this.renderWarningTable()
    } else if (type === HouseListDirectory.ERROR.name) {
      addressTable = this.renderErrorTable()
    } else if (type === HouseListDirectory.NG_LIST.name) {
      addressTable = this.renderNgListTable()
    }

    if (!this.getCurrentTabLoading() || this.getCurrentTabFilteredTotal() !== 0) {
      return (
        <div className={classes.addressTableContainer} style={{ margin: type === HouseListDirectory.NG_LIST.name ? '20px 150px' : '20px 0px' }}>
          {addressTable}
        </div>
      )
    }
  }

  renderMainTable = () => {
    const { limitUsage, showDemoData, user } = this.props;
    return (
      <div className={this.props.classes.addressTableContent}>
        <AddressTable
          filteredItems={this.state.filteredItems}
          isSelectAll={this.state.isSelectAll}
          selectCount={this.state.selectCount}
          menuItems={[]
            .concat(isEnabledUserRole(this.props.user, "house-list", "order-letter") && user && !user.min_letter_order_count ? [
              {
                name: "レター送付",
                func: (item) =>
                  showDemoData || limitUsage
                    ? this.togglePlanDialog()
                    : this.handleSendLetter(item),
              }
            ] : [])
            .concat((isEnabledUserRole(this.props.user, "house-list", "order-letter") && isEnableFollowCallHouseList(user)) ? [
              {
                name: "フォローコールのみ依頼",
                func: (item) =>
                  showDemoData || limitUsage
                    ? this.togglePlanDialog()
                    : this.confirmOrderedFollowCall(item),
              }
            ] : [])
            .concat([
              {
                name: "タイムライン",
                func: (item) => {
                  if (showDemoData) {
                    this.togglePlanDialog()
                  } else {
                    this.props.storeFilterValue(this.state.filterValue);
                    this.props.goTo(`/house-list/${item.id}/timeline`, {
                      filterValue: this.state.filterValue,
                      pathname: this.props.routerInfo.pathname,
                    });
                  }
                }
              }
            ])
            .concat(isEnabledUserRole(user, "house-list", "edit") ? [
              {
                name: "編集",
                func: (item) => {
                  if (showDemoData) {
                    this.togglePlanDialog();
                  } else if (item.address === null || item.post_code === null || item.honorific === null) {
                    this.toggleFollowCallAddressEditDialog(item);
                  } else {
                    this.toggleEditDialog(item);
                  }
                }
              },
              {
                name: "送付NGリストへ移動",
                func: (item) =>
                  showDemoData
                    ? this.togglePlanDialog()
                    : this.handleMoveNgSendings(item),
              },
              {
                name: "削除",
                func: (item) =>
                  showDemoData
                    ? this.togglePlanDialog()
                    : this.handleDelete(item),
              }
            ] : [])
          }
          onItemClicked={this.handleSelectItem}
          onTitleClicked={(item) => {
            this.props.storeFilterValue(this.state.filterValue);
            this.props.goTo(`/house-list/${item.id}/timeline`, {
              filterValue: this.state.filterValue,
              pathname: this.props.routerInfo.pathname,
            });
          }}
          selectAll={this.handleSelectAll}
          selectedItems={this.state.selectedItems}
          selectItem={this.handleSelectItem}
          style={{ marginTop: '10px' }}
          totalCount={this.getCurrentTabFilteredTotal()}
          type={this.props.type}
          unselectedItems={this.state.unselectedItems}
          onLabelClicked={(item) => item.address === null || item.post_code === null || item.honorific === null ? this.toggleFollowCallAddressEditDialog(item) : this.toggleEditDialog(item)}
          toggleSelectOptionDialog={this.toggleSelectOptionDialog}
          sortType={this.state.sortType}
          sortTypes={HouseListSortType}
          handleSortTypeChange={this.handleSortTypeChange}
          isDemo={this.props.showDemoData}
          disabled={this.disableHouselist()}
          togglePlanDialog={this.togglePlanDialog}
          user={this.props.user}
        />
      </div>
    )
  }

  renderWarningTable = () => {
    return (
      <AddressTable
        filteredItems={this.state.filteredItems}
        isSelectAll={this.state.isSelectAll}
        selectCount={this.state.selectCount}
        menuItems={[]
          .concat(isEnabledUserRole(this.props.user, "house-list", "edit") ? [
            { name: '警告の詳細', func: (item) => this.toggleDetailDialog(item) },
            { name: '編集', func: (item) => item.address === null || item.post_code === null || item.honorific === null ? this.toggleFollowCallAddressEditDialog(item) : this.toggleEditDialog(item) },
            { name: '削除', func: (item) => this.handleDelete(item) },
          ] : [])
        }
        onItemClicked={this.handleSelectItem}
        selectAll={this.handleSelectAll}
        selectedItems={this.state.selectedItems}
        selectItem={this.handleSelectItem}
        style={{ marginTop: '10px' }}
        totalCount={this.getCurrentTabFilteredTotal()}
        type={this.props.type}
        unselectedItems={this.state.unselectedItems}
        onLabelClicked={(item) => item.address === null || item.post_code === null || item.honorific === null ? this.toggleFollowCallAddressEditDialog(item) : this.toggleEditDialog(item)}
        toggleSelectOptionDialog={this.toggleSelectOptionDialog}
        sortType={this.state.sortType}
        sortTypes={WarningAddressSortType}
        handleSortTypeChange={this.handleSortTypeChange}
        isDemo={this.props.showDemoData}
        disabled={this.disableHouselist()}
        togglePlanDialog={this.togglePlanDialog}
        user={this.props.user}
      />
    )
  }

  renderErrorTable = () => {
    return (
      <AddressTable
        filteredItems={this.state.filteredItems}
        isSelectAll={this.state.isSelectAll}
        selectCount={this.state.selectCount}
        menuItems={[]
          .concat(isEnabledUserRole(this.props.user, "house-list", "edit") ? [
            { name: '編集', func: (item) => item.address === null || item.post_code === null || item.honorific === null ? this.toggleFollowCallAddressEditDialog(item) : this.toggleEditDialog(item) },
            { name: '削除', func: (item) => this.handleDelete(item) },
          ] : [])
        }
        onItemClicked={this.handleSelectItem}
        selectAll={this.handleSelectAll}
        selectedItems={this.state.selectedItems}
        selectItem={this.handleSelectItem}
        style={{ marginTop: '10px' }}
        totalCount={this.getCurrentTabFilteredTotal()}
        type={this.props.type}
        unselectedItems={this.state.unselectedItems}
        onLabelClicked={(item) => item.address === null || item.post_code === null || item.honorific === null ? this.toggleFollowCallAddressEditDialog(item) : this.toggleEditDialog(item)}
        toggleSelectOptionDialog={this.toggleSelectOptionDialog}
        sortType={this.state.sortType}
        sortTypes={ErrorAddressSortType}
        handleSortTypeChange={this.handleSortTypeChange}
        isDemo={this.props.showDemoData}
        disabled={this.disableHouselist()}
        togglePlanDialog={this.togglePlanDialog}
        user={this.props.user}
      />
    )
  }

  renderNgListTable = () => {
    return (
      <AddressTable
        filteredItems={this.state.filteredItems}
        isSelectAll={this.state.isSelectAll}
        selectCount={this.state.selectCount}
        menuItems={[]
          .concat(isEnabledUserRole(this.props.user, "house-list", "edit") ? [
            { name: '編集', func: (item) => this.toggleEditNgItemDialog(item) },
            { name: '送付NGを解除', func: (item) => this.props.deleteNgSendingsById(item.id) },
          ] : [])
        }
        onItemClicked={this.handleSelectItem}
        selectAll={this.handleSelectAll}
        selectedItems={this.state.selectedItems}
        selectItem={this.handleSelectItem}
        style={{ marginTop: '10px' }}
        totalCount={this.getCurrentTabFilteredTotal()}
        type={this.props.type}
        unselectedItems={this.state.unselectedItems}
        toggleSelectOptionDialog={this.toggleSelectOptionDialog}
        isDemo={this.props.showDemoData}
        disabled={this.disableHouselist()}
        togglePlanDialog={this.togglePlanDialog}
        user={this.props.user}
      />
    );
  }

  renderBottomMenu = () => {
    const { limitUsage, user } = this.props;
    let selectedCount = this.getSelectedCount();
    let menu = [];

    // 各ボックス共通項目
    menu = menu.concat(isEnabledUserRole(user, "house-list", "download-list") ? [
      { text: "CSVエクスポート", action: this.handleCsvExport },
    ] : []);

    // ボックスごとで項目設定
    if (this.props.type === HouseListDirectory.WARNING.name) {
      menu = menu.concat(isEnabledUserRole(user, "house-list", "edit") ? [
        { text: "削除", action: this.toggleDeleteDialog },
        { text: "メインボックスに登録", action: this.toggleConfirmDialog },
      ] : []);
    } else if (this.props.type === HouseListDirectory.ERROR.name) {
      menu = menu.concat(isEnabledUserRole(user, "house-list", "edit") ? [
        { text: "削除", action: this.toggleDeleteDialog },
      ] : []);
    } else if (this.props.type === HouseListDirectory.NG_LIST.name) {
      menu = menu.concat(isEnabledUserRole(user, "house-list", "edit") ? [
        { text: "選択したアイテムの送付NGを解除", action: this.handleDelete },
      ] : []);
    } else {
      menu = menu.concat(
        isEnabledUserRole(user, "house-list", "order-letter") ? [
          { text: "レター送付", action: limitUsage ? this.togglePlanDialog : this.confirmSendLetter, disableMessage: this.disableLetterOrderMessage() },
        ] : [])
        .concat((isEnabledUserRole(user, "house-list", "order-letter") && isEnableFollowCallHouseList(user)) ? [
          { text: "フォローコールのみ依頼", action: limitUsage ? this.togglePlanDialog : this.confirmOrderedFollowCall },
        ] : [])
        .concat(isEnabledUserRole(user, "house-list", "edit-tag") ? [
          { text: "リストに追加 / 削除", action: this.toggleEditTagsDialog },
        ] : [])
        .concat(isEnabledUserRole(user, "house-list", "edit") ? [
          { text: "法人番号を紐付ける", action: limitUsage ? this.togglePlanDialog : this.handleLinkCorporation },
          { text: "削除", action: this.toggleDeleteDialog },
        ] : []);
    }

    // valueは、重複を防ぐため、配列定義後に動的に付与
    menu.map((value, index) => {
      value['value'] = index;
      return value;
    });

    return (
      <BottomMenu
        numSelected={selectedCount}
        deselectAll={this.handleSelectAll}
        menuItems={menu}
        open={selectedCount > 0}
        buttonText="次へ"
        isDemo={this.props.showDemoData}
        togglePlanDialog={this.togglePlanDialog}
        isMinLetterOrderCount={isMinLetterOrderCount(user, selectedCount)}
        minLetterOrderCount={user && user.min_letter_order_count ? user.min_letter_order_count : 0}
      />);
  }

  renderLoader = () => {
    let isCurrentTabLoading = this.getCurrentTabLoading();
    let isCurrentTabEmpty = this.getCurrentTabFilteredTotal() === 0;

    return (
      <div style={{ width: '100%', position: 'relative', padding: isCurrentTabEmpty ? '120px 0px' : '50px 0px' }}>
        {(() => {
          if (isCurrentTabLoading && (!this.props.overwrite || isCurrentTabEmpty)) {
            return (
              <Loader type="color" size="large" />
            );
          }
        })()}
      </div>
    )
  }

  disableLetterOrderMessage = () => {
    const { user, classes } = this.props;
    let errors = [];

    if (!isMinLetterOrderCount(user, this.getSelectedCount())) {
      const minLetterOrderCount = (user && user.min_letter_order_count) ? user.min_letter_order_count : 0;
      errors.push("レター送付は" + minLetterOrderCount + "件以上から注文可能です");
    }

    if (errors.length > 0) {
      return errors.map((msg, i) => (
        <span key={i} className={classes.errorMessageRow}>
          <CancelCircle
            width={12}
            height={12}
            color="#F03A47"
            style={{ marginRight: "2px" }}
          />
          {msg}
        </span>
      ));
    } else {
      return "";
    }
  };

  render() {
    const { classes, type, isLoadingSidebar, isLoadingCheck } = this.props;
    let notification, addAddressDialog, addFollowCallAddressDialog, selectAddAddressDialog, createDialog, createFollowCallAddressDialog, addExcelDialog, addFollowCallAddressExcelDialog, createNgItemDialog, addNgExcelDialog, manageTagsDialog, detailDialog,
      editNgItemDialog, deleteDialog, editDialog, followCallAddressEditDialog, selectOptionDialog, editTagsDialog, createListDialog, confirmDialog, bottomMenu;

    if (this.state.showNotification) { notification = this.renderNotification(); }
    if (this.state.showAddAddressDialog) { addAddressDialog = this.renderAddAddressDialog(); }
    if (this.state.showAddFollowCallAddressDialog) { addFollowCallAddressDialog = this.renderAddFollowCallAddressDialog(); }
    if (this.state.showSelectAddAddressDialog) { selectAddAddressDialog = this.renderSelectAddAddressDialog(); }
    if (this.state.showCreateDialog) { createDialog = this.renderCreateDialog(); }
    if (this.state.showCreateFollowCallAddressDialog) { createFollowCallAddressDialog = this.renderCreateFollowCallAddressDialog(); }
    if (this.state.showAddExcelDialog) { addExcelDialog = this.renderAddExcelDialog(); }
    if (this.state.showAddFollowCallAddressExcelDialog) { addFollowCallAddressExcelDialog = this.renderAddFollowCallAddressExcelDialog(); }
    if (this.state.showCreateNgItemDialog) { createNgItemDialog = this.renderCreateNgItemDialog(); }
    if (this.state.showAddNgExcelDialog) { addNgExcelDialog = this.renderAddNgExcelDialog(); }
    if (this.state.showManageTagsDialog) { manageTagsDialog = this.renderManageTagsDialog(); }
    if (this.state.showDetailDialog) { detailDialog = this.renderDetailDialog(); }
    if (this.state.showEditNgItemDialog) { editNgItemDialog = this.renderEditNgItemDialog(); }
    if (this.state.showDeleteDialog) { deleteDialog = this.renderDeleteDialog(); }
    bottomMenu = this.renderBottomMenu();
    if (this.state.showEditDialog) { editDialog = this.renderEditDialog(); }
    if (this.state.showFollowCallAddressEditDialog) { followCallAddressEditDialog = this.renderFollowCallAddressEditDialog(); }
    if (this.state.showSelectOptionDialog) { selectOptionDialog = this.renderSelectOptionDialoog(); }
    if (this.state.showEditTagsDialog) { editTagsDialog = this.renderEditTagsDialog(); }
    if (this.state.showCreateListDialog) { createListDialog = this.renderCreateListDialog(); }
    if (this.state.showConfirmDialog) { confirmDialog = this.renderConfirmDialog(); }

    let selectedCount = this.getSelectedCount();
    let showScrollBtn = this.state.showScrollBtn && selectedCount === 0;

    return (
      <Wrapper className={classes.root}>
        <Header title="自社リスト" type="dark" hasBackBtn={false} />
        <div className={classes.main}>
          <div className={classes.header}>
            <AddressBookHeader
              user={this.props.user}
              type={this.props.type}
              goTo={this.props.goTo}
              handleCsvExportAll={this.handleCsvExportAll}
              resetContainer={this.resetContainer}
              toggleAddAddressDialog={this.toggleAddAddressDialog}
              toggleSelectAddAddressDialog={this.toggleSelectAddAddressDialog}
              getCurrentTabTotal={this.getCurrentTabTotal}
              limitUsage={this.props.limitUsage}
              isDemo={this.props.showDemoData}
              disabled={this.disableHouselist()}
              togglePlanDialog={this.togglePlanDialog}
            />
          </div>
          {(() => {
            if (this.getCurrentTabTotal() === 0 && !this.getCurrentTabLoading() && this.props.isLoaded) {
              return (
                <div className={classes.content}>
                  {this.renderEmptyContent()}
                </div>
              )
            } else if ((this.getCurrentTabTotal() === 0 && this.getCurrentTabLoading()) || (this.state.isSidebarLoaded === false && isLoadingSidebar !== 0) || (isLoadingCheck)) {
              return (
                <div className={classes.content}>
                  <Loader type="color" size="large" />
                </div>
              )
            } else {
              return (
                <div className={classes.content}>
                  {this.renderSidebar()}
                  <div className={classes.mainContainer} ref={this.setAddressTableContent}>
                    {this.renderWarningMessage()}
                    {this.renderMainPanelHeader()}
                    {this.renderSearchNotification()}
                    {this.renderAddressTable()}
                    {this.renderLoader()}

                    <div className={classes.bottomMenu} style={{ width: type === HouseListDirectory.NG_LIST.name ? '100%' : 'calc(100% - 300px)' }}>
                      {bottomMenu}
                    </div>

                    <div className={classes.scrollBtn} style={{
                      opacity: showScrollBtn ? 1 : 0,
                      visibility: showScrollBtn ? 'visible' : 'hidden',
                      transition: 'all 0.3s',
                      WebkitTransition: 'all 0.3s',
                      left: this.props.type === HouseListDirectory.NG_LIST.name ? "170px" : "320px",
                    }}>
                      <Button
                        text="↑上に戻る"
                        type="ghost"
                        handleClickButton={this.scrollToTop}
                        style={{
                          color: '#71737B',
                          width: 'unset',
                          padding: '0px 5px',
                          marginTop: '8px',
                          border: '#D8DBDF 1px solid',
                          background: 'transparent',
                        }}
                      />
                    </div>

                  </div>
                </div>
              )
            }
          })()}
        </div>
        {notification}
        {addAddressDialog}
        {addFollowCallAddressDialog}
        {selectAddAddressDialog}
        {createDialog}
        {createFollowCallAddressDialog}
        {addExcelDialog}
        {addFollowCallAddressExcelDialog}
        {createNgItemDialog}
        {addNgExcelDialog}
        {manageTagsDialog}
        {detailDialog}
        {editNgItemDialog}
        {deleteDialog}
        {editDialog}
        {followCallAddressEditDialog}
        {selectOptionDialog}
        {editTagsDialog}
        {createListDialog}
        {confirmDialog}
        {this.renderPlanDialog()}
        {this.renderDemoNotification()}
        {this.renderDemoDialog()}
        {this.renderSalesforceInfoBox()}
        {this.renderInquiryDialog()}
        {this.renderOrderDisableDialog()}
        {this.renderConfirmSendDialog()}
        {this.renderConfirmFollowCallOrderDialog()}
        {this.renderSubmitFollowCallOrderDialog()}
      </Wrapper>
    )
  }
}

HouseList.propTypes = {
  classes: PropTypes.object.isRequired,
  cookies: instanceOf(Cookies).isRequired,
  type: PropTypes.string,
  getErrorAddress: PropTypes.func,
  getWarningAddress: PropTypes.func,
  getNgSendings: PropTypes.func,
  routerInfo: PropTypes.object,
  filterValue: PropTypes.object,
  pageInfo_all: PropTypes.object,
  pageInfo_error: PropTypes.object,
  pageInfo_warning: PropTypes.object,
  pageInfo_ngList: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingSidebar: PropTypes.number,
  isLoaded: PropTypes.bool,
  storeFilterValue: PropTypes.func,
  goTo: PropTypes.func,
  user: PropTypes.object,
  limitUsage: PropTypes.bool,
  isVerifying: PropTypes.bool,
  getUserInfo: PropTypes.func,
  getSalesforceConfig: PropTypes.func,
  getAddressTags: PropTypes.func,
  getAddressImportHistoryTags: PropTypes.func,
  getAddressTotals: PropTypes.func,
  getAddressCorporationDifferencesCount: PropTypes.func,
  postAddressesRestoreNgSendings: PropTypes.func,
  getSalesforceSyncLastUpdate: PropTypes.func,
  getLetterOrderList: PropTypes.func,
  getFollowCallOrderList: PropTypes.func,
  syncCount: PropTypes.number,
  getFailedLinkAddress: PropTypes.func,
  isMixedAddresses: PropTypes.bool,
  hasLetterOrderHistoryNames: PropTypes.array,
  duplicateNames: PropTypes.array,
  orderedFollowCallNames: PropTypes.array,
  addressItems: PropTypes.array,
  errorItems: PropTypes.array,
  warningItems: PropTypes.array,
  showDemoData: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  warningMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  undoable: PropTypes.bool,
  isDeleting: PropTypes.bool,
  isSaving: PropTypes.bool,
  isPutting: PropTypes.bool,
  isUpdatingTags: PropTypes.bool,
  isDeletingAddressTags: PropTypes.bool,
  isUpdatingAddressTags: PropTypes.bool,
  isUpdatingDifferences: PropTypes.bool,
  isOverwritingWarningAddress: PropTypes.bool,
  isPostWarningAddressWithExecutivePerson: PropTypes.bool,
  isImporting: PropTypes.bool,
  overwrite: PropTypes.bool,
  isLoadingNgList: PropTypes.bool,
  getExecutiveList: PropTypes.func,
  failedLinkCorporationCount: PropTypes.number,
  postAddressCorporationDifferencesVerify: PropTypes.func,
  postAddressCorporationDifferencesUpdateDifference: PropTypes.func,
  addItems: PropTypes.func,
  postErrorAddress: PropTypes.func,
  postWarningAddress: PropTypes.func,
  addItemsFromExcel: PropTypes.func,
  getSendAddressesConfirm: PropTypes.func,
  editAddress: PropTypes.func,
  getOrderedFollowCallConfirm: PropTypes.func,
  postFollowCallOrdersOrder: PropTypes.func,
  postAddressesMoveNgSendings: PropTypes.func,
  deleteErrorAddressMulti: PropTypes.func,
  deleteWarningAddressMulti: PropTypes.func,
  deleteAddressMulti: PropTypes.func,
  deleteNgSendings: PropTypes.func,
  postWarningAddressesMulti: PropTypes.func,
  putAddressTagMulti: PropTypes.func,
  putAddressLinkCorporation: PropTypes.func,
  totalAddresses: PropTypes.number,
  totalWarningAddresses: PropTypes.number,
  totalErrorAddresses: PropTypes.number,
  totalNgList: PropTypes.number,
  selectAddress: PropTypes.object,
  prevItem: PropTypes.object,
  postWarningAddressRestore: PropTypes.func,
  tags: PropTypes.array,
  importHistories: PropTypes.array,
  lastUpdate: PropTypes.string,
  postSalesforceSync: PropTypes.func,
  letterOrderList: PropTypes.array,
  followCallOrderList: PropTypes.array,
  error: PropTypes.object,
  postNgSendingsExcel: PropTypes.func,
  postNgSendings: PropTypes.func,
  putWarningAddressesTagsDeleteMulti: PropTypes.func,
  putErrorAddressesTagsDeleteMulti: PropTypes.func,
  putAddressesTagsDeleteMulti: PropTypes.func,
  putWarningAddressesTagsUpdateTagNameMulti: PropTypes.func,
  putErrorAddressesTagsUpdateTagNameMulti: PropTypes.func,
  putAddressesTagsUpdateTagNameMulti: PropTypes.func,
  postWarningAddressOverwrite: PropTypes.func,
  postWarningAddressWithExecutivePerson: PropTypes.func,
  getAddressSuggestCorporations: PropTypes.func,
  getWarningAddressSuggestCorp: PropTypes.func,
  getErrorAddressSuggestCorp: PropTypes.func,
  corporations: PropTypes.array,
  isLoadingCorp: PropTypes.bool,
  putNgSendings: PropTypes.func,
  selectedAddressTags: PropTypes.array,
  isLoadingSelectedAddressTags: PropTypes.bool,
  getSelectedAddressTags: PropTypes.func,
  isPostingFollowCallOrder: PropTypes.bool,
  addressCorporationDifferencesCount: PropTypes.object,
  deleteNgSendingsById: PropTypes.func,
  isLoadingCheck: PropTypes.bool,
};

export default withCookies(withStyles(styles)(HouseList));



// WEBPACK FOOTER //
// ./src/components/AddressBook/HouseList.jsx